export class CommonLocale {
	static CommonOkButtonText = "common.okButtonText";
	static CommonAddButtonText = "common.addButtonText";
	static CommonEditButtonText = "common.editButtonText";
	static CommonSaveButtonText = "common.saveButtonText";
	static CommonApplyButtonText = "common.applyButtonText";
	static CommonCancelButtonText = "common.cancelButtonText";
	static CommonDeleteButtonText = "common.deleteButtonText";
	static CommonDuplicateButtonText = "common.duplicateButtonText";
	static CommonSetInternalButtonText = "common.setInternalButtonText";
	static CommonSetDraftButtonText = "common.setDraftButtonText";
	static CommonMoveUpButtonText = "common.moveupButtonText";
	static CommonMoveDownButtonText = "common.movedownButtonText";
	static CommonYesButtonText = "common.yesButtonText";
	static CommonNoButtonText = "common.noButtonText";
	static CommonCloseButtonText = "common.closeButtonText";
	static CommonWarningTitle = "common.warningTitle";
	static CommonSuccessTitle = "common.successTitle";
	static CommonFailedTitle = "common.failedTitle";
	static CommonHttpAggregate = "common.httpAggregate";
	static CommonHttpArgumentIsNullOrInvalid = "common.httpArgumentIsnullorInvalid";
	static CommonHttpBadRequest = "common.httpBadrequest";
	static CommonHttpCodeHasBeenUsed = "common.httpCodeHasBeenUsed";
	static CommonHttpCodeNotExist = "common.httpCodeNotExist";
	static CommonHttpInvalidGrant = "common.httpInvalidGrant";
	static CommonHttpLengthOverRun = "common.httpLengthOverRun";
	static CommonHttpNoPermission = "common.httpNoPermission";
	static CommonHttpNotFound = "common.httpNotFound";
	static CommonHttpServerError = "common.httpServerError";
	static CommonHttpStrongAssociation = "common.httpStrongAssociation";
	static CommonHttpTargetDisabled = "common.httpTargetDisabled";
	static CommonHttpTargetHasExisted = "common.httpTargetHasExisted";
	static CommonHttpTargetIsNull = "common.httpTargetIsNull";
	static CommonHttpTooManyRequest = "common.httpTooManyRequests";
	static CommonHttpUnknown = "common.httpUnknown";
	static CommonHttpUnsuportedOperation = "common.httpUnsuportedOperation";
	static CommonHttpDuplicateWordException = "common.httpDuplicateWordException";
	static NoVersionGroupMsg = "common.noversiongroup.message";
	static CommonLeaveDirtyWarning = "common.leave.dirty.warn";
	static CommonRoleSystemAdmin = "common.role.systemadmin";
	static CommonRoleGlobalHead = "common.role.globalhead";
	static CommonRoleContentAdmin = "common.role.contentadmin";
	static CommonRoleTrainingAdmin = "common.role.trainingadmin";
	static CommonRoleRegionAdmin = "common.role.regionadmin";
	static CommonRoleAccountManager = "common.role.accountmanager";
	static CommonRoleTrainingManager = "common.role.trainingmanager";
	static CommonRoleTrainer = "common.role.trainer";
	static CommonRoleSchoolAdmin = "common.role.schooladmin";
	static CommonRoleCampusAdmin = "common.role.campusadmin";
	static CommonRoleTeacher = "common.role.teacher";
	static CommonRoleParent = "common.role.parent";
	static CommonFieldLength = "common.field.length";
	static CommonFieldRequired = "common.field.required";
	static CommonFieldVersionGroup = "common.field.versiongroup";
	static CommonQuickViewTitle = "common.quickView.title";
	static CommonQuickViewNoRecordsMessage = "common.quickView.noRecordsMessage";
	static CommonFieldMethodology = "common.field.methodology";
	static CommonMethodologyAllText = "common.methodology.all";
	static CommonMethodologyClassicText = "common.methodology.classic";
	static CommonMethodologyDigitalText = "common.methodology.digital";
	static CommonMethodologyRemoteText = "common.methodology.remote";
	static CommonMethodologyIndependentText = "common.methodology.independent";
	static CommonMethodologyREPText = "common.methodology.rep";
	static CommonDoubleClickToEdit = "common.doubleclick.toedit";
	static CommonDayMonday = "common.day.monday";
	static CommonDayTuesday = "common.day.tuesday";
	static CommonDayWednesday = "common.day.wednesday";
	static CommonDayThursday = "common.day.thursday";
	static CommonDayFriday = "common.day.friday";
	static CommonDaySaturday = "common.day.saturday";
	static CommonDaySunday = "common.day.sunday";
	static CommonContentConversationAssociationMessage = "common.contentconversationassociation.message";
	static CommonNotContentConversationMessage = "common.notcontentconversation.message";
	static CommonContentConversationAssociationDeleteMessage = "common.contentconversationassociation.deletemessage";
	static CommonContentConversationAssociationDraftMessage = "common.contentconversationassociation.draftmessage";
	static CommonContentConversationAssociationPublishMessage = "common.contentconversationassociation.publishmessage";
	static CommonContentNotExist = "common.content.notexist";
	static CommonSpecialDesignationNotExist = "common.specialdesignation.notexist";
	static CommonManageOrderButtonText = "common.manageorderbuttontext";
}

export class ImpersonationLocale {
	static BannerLoggedAs = "impersonation.banner.impersonationswitchback";
	static BannerClickHere = "impersonation.banner.clickhere";
	static BannerToSwitchBack = "impersonation.banner.toswitchback";
	static HeaderMenuImpersonating = "impersonation.header.impersonating";
	static HeaderMenuStopImpersonating = "impersonation.header.stopimpersonation";
}

export class AppNavigationLocale {
	static AppNavigationDashboard = "appNavigation.dashboard";
	static AppNavigationUserManagement = "appNavigatoin.userManagement";
	static AppNaviagtionAuditHistoryDescription = "appNavigatoin.audithistory.description";
	static AppNavigationWordCount = "appNavigation.wordCount";
	static AppNavigationWordManager = "appNavigation.wordManager";
	static AppNavigationTextWriter = "appNavigation.textWriter";
	static AppNavigationTextGuardian = "appNavigation.textGuardian";
	static AppNavigationCategoryManager = "appNavigation.categoryManager";
	static AppNavigationPermissionManager = "appNavigation.permissionManger";
	static AppNavigationObjectiveManager = "appNavigation.objectiveManger";
	static AppNavigationLessonPlanManager = "appNavigation.lessonplanManger";
	static AppNavigationLessonPlanVersion = "appNavigation.lessonplanversion";
	static AppNavigationLessonPlanList = "appNavigation.lessonplanlist";
	static AppNavigationLessonPlanTemplate = "appNavigation.lessonplantemplate";
	static AppNavigationStudentActivities = "appNavigation.lessonplanactivites";
	static AppNavigationCommonItems = "appNavigation.commonItems";
	static AppNavigationLessonPlanReports = "appNavigation.lessonPlanReports";
	static AppNavigationContentAdministrators = "appNavigation.contentAdministrators";
	static AppNavigationPermissions = "appNavigation.permissions";
	static AppNavigationListManagement = "appNavigation.listManagement";
	static AppNavigationUnitList = "appNavigation.unitList";
	static AppNavigationCategoryList = "appNavigation.categoryList";
	static AppNavigationAssetList = "appNavigation.assetList";
	static AppNavigationCurriculumManagement = "appNavigation.curriculumManagement";
	static AppNavigationComponents = "appNavigation.components";
	static AppNavigationVocabulary = "appNavigation.vocabulary";
	static AppNavigationPhonogram = "appNavigation.phonogram";
	static AppNavigationRevisionManager = "appNavigation.revisionmanager";
	static AppNavigationRevisionManagerDescription = "appNavigation.revisionmanager.description";
	static AppNavigationObjectiveList = "appNavigation.objectiveList";
	static AppNavigationLanguageFunctionManagement = "appNavigation.languageFunctionManagement";
	static AppNavigationLFList = "appNavigation.lfList";
	static AppNavigationLFUsageStatistics = "appNavigation.lfUsageStats";
	static AppNavigationLFUsageDetails = "appNavigation.lfUsageDetails";
	static AppNavigationLFSearch = "appNavigation.lfSearch";
	static AppNavigationVocabularyManagement = "appNavigation.vocabularyManagement";
	static AppNavigationWordPhraseSearch = "appNavigation.wordPhraseSearch";
	static AppNavigationWordDetails = "appNavigation.wordDetails";
	static AppNavigationTextAnalysisReports = "appNavigation.textAnalysisReports";
	static AppNavigationRWTextAnalysis = "appNavigation.rwTextAnalysis";
	static AppNavigationTextChangeAnalysis = "appNavigation.textChangeAnalysis";
	static AppNavigationNewTextAnalysis = "appNavigation.newTextAnalysis";
	static AppNavigationNonCurriculumComponents = "appNavigation.noncurriculumcomponents";
	static AppNavigationFocusWords = "appNavigation.focuswords";
	static AppNavigationAuditHistory = "appNavigation.auditHistory";
	static AppNavigationAuditHistoryDescription = "appNavigation.audithistory.description";
	static AppNavigationFocusWordsDescription = "appNavigation.focuswords.description";
	static AppNavigationAssetListDescription = "appNavigation.assetlist.description";
	static AppNavigationActivitiesDescription = "appNavigation.activities.description";
	static AppNavigationConversationTemplatesDescription = "appNavigation.mastertemplates.description";
	static AppNavigationActiveLearn = "appNavigation.activelearn.title";
	static AppNavigationConversationDescription = "appNavigation.conversations.description";
}

export class ErrorLocale {
	static UnauthorizedMessage = "error.unauthorized";
	static NotFoundMessage = "error.notfound";
}

export class ListStateLocale {
	static ListStateLocaleAll = "listStateLocale.all";
	static ListStateLocaleActive = "listStateLocale.active";
	static ListStateLocaleInactive = "listStateLocale.inactive";
	static ListStateLocalePending = "listStateLocale.pending";
	static ListStateLocaleFuture = "listStateLocale.future";
	static ListStateLocaleExposure = "listStateLocale.exposure";
	static ListStateLocaleRWAssigned = "listStateLocale.rwAssigned";
	static ListStateLocaleVSAssigned = "listStateLocale.vsAssigned";
	static ListStateLocaleRMQueued = "listStateLocale.rmqueued";
	static ListStateLocaleRMProcessing = "listStateLocale.rmprocessing";
	static ListStateLocaleRMScheduled = "listStateLocale.rmscheduled";
	static ListStateLocaleRMDeleted = "listStateLocale.rmdeleted";
}

export class WordManagerLocale {
	static WordManagerDescription = "wordManager.description";
	static WordManagerTitle = "wordManager.title";
	static WordManagerSearchLabel = "wordManager.searchLabel";
	static WordManagerSearchPlaceholder = "wordManager.searchPlaceholder";
	static WordManagerUnitLabel = "wordManager.unitLabel";
	static WordManagerWordColumn = "wordManager.wordColumn";
	static WordManagerFistUsedGSColumn = "wordManager.firstUsedGSColumn";
	static WordManagerFistUsedLSColumn = "wordManager.firstUsedLSColumn";
	static WordManagerPronunciationColumn = "wordManager.pronunciationColumn";
	static WordManagerDefinitionColumn = "wordManager.definitionColumn";
	static WordManagerLemmaColumn = "wordManager.lemmaColumn";
	static WordManagerDeleteWarning = "wordManager.deleteWarning";
	static WordManagerDeleteTooltip = "wordManager.deleteTooltip";
	static WordManagerDeleteModalTitle = "wordManager.deleteModalTitle";
	static WordManagerAddWordButtonText = "wordManager.addWordButtonText";
	static WordManagerDisplayButtonText = "wordManager.displayButtonText";
	static WordManagerLanguageSkillLabel = "wordManager.languageSkillLabel";
	static WordManagerAllSkillOption = "wordManager.allSkillOption";
	static WordManagerAllLevelOption = "wordManager.allLevelOption";
	static WordManagerNoneLevelOption = "wordManager.noneLevelOption";
	static WordManagerVpcOnlyCheckbox = "wordManager.vpcOnlyCheckbox";
	static WordManagerExportTitle = "wordManager.export.title";
}

export class WordManagerFormLocale {
	static WordManagerFormAddNewTitle = "wordManagerForm.addNewTitle";
	static WordManagerFormEditTitle = "wordManagerForm.editTitle";
	static WordManagerFormWordLabel = "wordManagerForm.wordLabel";
	static WordManagerFormPronunciationLabel = "wordManagerForm.pronunciationLabel";
	static WordManagerFormPartOfSpeechLabel = "wordManagerForm.partOfSpeechLabel";
	static WordManagerFormDescriptionLabel = "wordManagerForm.descriptionLabel";
	static WordManagerFormLemmaLabel = "wordManagerForm.lemmaLabel";
	static WordManagerFormRWAssignedUnitLabel = "wordManagerForm.rwAssignedUnitLabel";
	static WordManagerFormRWAssignedUnitGroupLabel = "wordManagerForm.rwAssignedUnitGroupLabel";
	static WordManagerFormGsExposureUnitLabel = "wordManagerForm.gsExposureUnitLabel";
	static WordManagerFormLsExposureUnitLabel = "wordManagerForm.lsExposureUnitLabel";
	static WordManagerFormSaveButtonText = "wordManagerForm.saveButtonText";
	static WordManagerFormCancelButtonText = "wordManagerForm.cancelButtonText";
	static WordManagerFormWordRequiredMessage = "wordManagerForm.wordRequiredMessage";
	static WordManagerFormNoneUnitText = "wordManagerForm.noneUnitText";
	static WordManagerFormNewLemmaText = "wordManagerForm.newLemmaText";
	static WordManagerFormDuplicateWordException = "wordManagerForm.duplicateWordException";
	static WordManagerFormVPCReferenceException = "wordManagerForm.vpcReferenceException";
	static WordManagerFormHasAssociateRelateItem = "wordManagerForm.hasAssociateRelateItem";
	static WordManagerFormSaveSuccessMsg = "wordManagerForm.saveSuccessMsg";

	static WordManagerFormWarningWordDelete = "wordManagerForm.warning.wordDelete";
	static WordManagerFormWarningWordNotUsedInUnit = "wordManagerForm.warning.wordNotUsedInUnit";
	static WordManagerFormRwGroupRequiredMessage = "wordManagerForm.rwGroupRequiredMessage";

	static WordManagerFormVpcUsageLabel = "wordManagerForm.vpcUsageLable";

	static WordManagerFormVpcUsageButton = "wordManagerForm.vpcUsageButton";
	static WordManagerFormVpcUsageAdd = "wordManagerForm.vpcUsageAdd";
	static WordManagerFormVpcUsageSave = "wordManagerForm.vpcUsageSave";
	static WordManagerFormVpcUsageCancel = "wordManagerForm.vpcUsageCancel";

	static WordManagerFormVpcUsageUnitColumn = "wordManagerForm.vpcUsageUnitColumn";
	static WordManagerFormVpcUsageSequenceColumn = "wordManagerForm.vpcUsageSequenceColumn";
	static WordManagerFormVpcUsageSequenceRequired = "wordManagerForm.vpcUsageSequenceRequired";
	static WordManagerFormVpcUsageReviewColumn = "wordManagerForm.vpcUsageReviewColumn";
	static WordManagerFormVpcUsageMediaColumn = "wordManagerForm.vpcUsageMediaColumn";
	static WordManagerFormVpcVGColumn = "wordManagerForm.vpcVGColumn";
	static WordManagerFormVpcUsageMediaView = "wordManagerForm.vpcUsageMediaView";
	static WordManagerFormVpcUsageMediaProcessing = "wordManagerForm.vpcUsageMediaProcessing";
	static WordManagerFormVpcUsageMediaRemove = "wordManagerForm.vpcUsageMediaRemove";
	static WordManagerFormVpcUsageMediaNone = "wordManagerForm.vpcUsageMediaNone";
	static WordManagerFormVpcUsageMediaUpload = "wordManagerForm.vpcUsageMediaUpload";
	static WordManagerFormVpcUsageMediaInvalid = "wordManagerForm.vpcUsageMediaInvalid";
	static WordManagerFormVpcUsageMediaUploadText = "wordManagerForm.vpcUsageMediaUploadText";
	static WordManagerFormVpcUsageVGNoneText = "wordManagerForm.vpcUsageVGNonetxt";
	static WordManagerFormWarningDuplicatevpcunits = "wordManagerForm.warning.duplicateVpcUnits";
	static WordManagerNoWordChangeMsg = "wordManagerForm.warning.wordchange";
}

export class PhonogramManagerLocale {
	static VersionMessage = "phonogramManager.versionMessage";
	static Title = "phonogramManager.title";
	static Description = "phonogramManager.description";
	static FilterSearchLabel = "phonogramManager.filter.searchLabel";
	static FilterUnitLabel = "phonogramManager.filter.unitLabel";
	static FilterUnitAll = "phonogramManager.filter.unitAll";
	static FilterTypeAll = "phonogramManager.filter.typeAll";
	static FilterTypePhonogramCard = "phonogramManager.filter.typePhonogramCard";
	static FilterTypePhonogramWordCard = "phonogramManager.filter.typePhonogramWordCard";
	static FilterButton = "phonogramManager.filter.button";

	static ActionAdd = "phonogramManager.action.add";
	static ActionExportFilename = "phonogramManager.action.exportFilename";

	static GridPhonogramColumn = "phonogramManager.grid.phonogramColumn";
	static GridTypeColumn = "phonogramManager.grid.typeColumn";
	static GridTypePhonogramCard = "phonogramManager.grid.typePhonogramCard";
	static GridTypePhonogramWordCard = "phonogramManager.grid.typePhonogramWordCard";
	static GridFocusUnitColumn = "phonogramManager.grid.focusUnitColumn";
	static GridReviewUnitColumn = "phonogramManager.grid.reviewUnitColumn";
}

export class PhonogramManageFormLocale {
	static TitleNew = "phonogramManageForm.titleNew";
	static TitleEdit = "phonogramManageForm.titleEdit";

	static NameLabel = "phonogramManageForm.nameLabel";
	static NameRequired = "phonogramManageForm.nameRequired";
	static TypeLabel = "phonogramManageForm.typeLabel";
	static TypePhonogramCard = "phonogramManageForm.typePhonogramCard";
	static TypePhonogramWordCard = "phonogramManageForm.typePhonogramWordCard";
	static FocusUnitLabel = "phonogramManageForm.focusUnitLabel";
	static FocusUnitRequired = "phonogramManageForm.focusUnitRequired";
	static MaxReviewUnitLabel = "phonogramManageForm.maxReviewUnitLabel";
	static MaxReviewUnitRequired = "phonogramManageForm.maxReviewUnitRequired";
	static RelatedPhonogramLabel = "phonogramManageForm.relatedPhonogramLabel";
	static RelatedPhonogramRequired = "phonogramManageForm.relatedPhonogramRequired";

	static MediaTitle = "phonogramManageForm.mediaTitle";
	static MediaViewingContentLabel = "phonogramManageForm.mediaViewingContentLabel";
	static MediaViewingContentViewTooltip = "phonogramManageForm.mediaViewingContentViewTooltip";
	static MediaAudioLabel = "phonogramManageForm.mediaAudioLabel";
	static MediaAudioPlayTooltip = "phonogramManageForm.mediaAudioPlayTooltip";
	static MediaProcessing = "phonogramManageForm.mediaProcessing";
	static SlotLabel = "phonogramManageForm.SlotLabel";
	static CurrentMediaLabel = "phonogramManageForm.currentMediaLabel";
	static CurrentMediaNone = "phonogramManageForm.currentMediaNone";
	static CurrentMediaRemove = "phonogramManageForm.currentMediaRemove";
	static currentMediaUpload = "phonogramManageForm.currentMediaUpload";
	static CurrentMediaInvalidMessage = "phonogramManageForm.currentMediaInvalidMessage";

	static DeleteButton = "phonogramManageForm.deleteButton";
	static CancelButton = "phonogramManageForm.cancelButton";
	static SaveButton = "phonogramManageForm.saveButton";

	static DeleteConfirmationTitle = "phonogramManageForm.deleteConfirmationTitle";
	static DeleteConfirmationText = "phonogramManageForm.deleteConfirmationText";
	static DeleteConfirmationYes = "phonogramManageForm.deleteConfirmationYes";
	static DeleteConfirmationCancel = "phonogramManageForm.deleteConfirmationCancel";
	static DeleteConfirmationReferenceErrorMsg = "phonogramManageForm.deleteConfirmationReferenceErrorMsg";
	static DeleteConfirmationPCReferenceInComponentMsg =
		"phonogramManageForm.deleteConfirmationPCReferenceInComponentMsg";
	static DeleteConfirmationPWCReferenceInComponentMsg =
		"phonogramManageForm.deleteConfirmationPWCReferenceInComponentMsg";
	static PhonogramEditedSuccessfullyMessage = "phonogramManageForm.phonogramEdited";
	static PhonogramAddedSuccessfullyMessage = "phonogramManageForm.phonogramAdded";
	static PhonogramDeletedSuccessfullyMessage = "phonogramManageForm.phonogramDeleted";
}

export class ChildNavigationLocale {
	static ChildNavigationTextAnalysis = "childNavigation.textAnalysis";
	static ChildNavigationReaderWriterTextAnalysis = "childNavigation.readerWriterTextAnalysis";
	static ChildNavigationWordCount = "childNavigation.wordCount";
	static ChildNavigationWordPhraseSearch = "childNavigation.wordPhraseSearch";
	static ChildNavigationTextChangeAnalysis = "childNavigation.textChangeAnalysis";
	static ChildNavigationWordSpec = "childNavigation.wordSpec";
	static ChildNavigationUnitList = "childNavigation.unitList";
	static ChildNavigationTitleList = "childNavigation.titleList";
	static ChildNavigationVocabularyList = "childNavigation.vocabularyList";
	static ChildNavigationPhraseList = "childNavigation.phraseList";
	static ChildNavigationLanguageFunctions = "childNavigation.languageFunctions";
	static ChildNavigationText = "childNavigation.text";
	static ChildNavigationContentExposure = "childNavigation.contentexposure";
	static ChildNavigationREPTabText = "childNavigation.repTabText";
	static ChildNavigationMediaTabText = "childNavigation.mediaTabText";
	static ChildNavigationContentObjective = "childNavigation.cotentObjective";
	static ChildNavigationSubtitles = "childNavigation.subtitles";
	static ChildNavigationComponents = "childNavigation.components";
	static ChildNavigationTalkMode = "childNavigation.talkMode";
	static ChildNavigationTitleListPhraseList = "childNavigation.titlePhraseList";
	static ChildNavigationTagList = "childNavigation.tagList";
	static ChildNavigationTotalsReport = "childNavigation.totalsReport";
	static ChildNavigationDetailsReport = "childNavigation.detailsReport";
	static ChildNavigationLFSearch = "childNavigation.lfSearch";
	static ChildNavigationTeachingActivities = "childNavigation.teachingActivities";
	static ChildNavigationTransitions = "childNavigation.transitions";
	static ChildNavigationScopeSequence = "childNavigation.scopeSequence";
	static ChildNavigationComponentObjectives = "childNavigation.componentObjectives";
	static ChildNavigationUnitOverview = "childNavigation.unitOverview";
	static ChildNavigationVPCOverview = "childNavigation.vpcOverview";
	static ChildNavigationComponentToObjective = "childNavigation.componentToObjective";
	static ChildNavigationMasteryQuestionToObjective = "childNavigation.masteryQuestionToObjective";
	static ChildNavigationFocusWordsByChapter = "childNavigation.focusWordsByChapter";
	static ChildNavigationMediaChangeImpact = "childNavigation.mediaChangeImpact";
	static ChildNavigationFallback = "childNavigation.fallback";
	static ChildNavigationConversations = "childNavigation.conversations";
	static ChildNavigationOpenClose = "childNavigation.openclose";
	static ChildNavigationContentManageChapters = "childNavigation.ManageChapters";
	static ChildNavigationContentConversation = "childNavigation.content.conversation";
	static ChildNavigationFocusWords = "childNavigation.focusWords";
}

export class CategoryManagerLocale {
	static CategoryManagerCreateNameRequired = "categoryManager.create.name.required";
	static CategoryManagerEditNameRequired = "categoryManager.edit.name.required";
	static CategoryManagerMoveChooseCat = "categoryManager.move.choose.cat";
	static CategoryManagerMoveChooseType = "categoryManager.move.choose.type";
	static CategoryManagerCreateTypeLabel = "categoryManager.create.name.typeLabel";
	static CategoryManagerCreateCatLabel = "categoryManager.create.name.catLabel";
	static CategoryManagerCreateEditTypeUnique = "categoryManager.create.edit.typeUnique";
	static CategoryManagerCreateEditCatUnique = "categoryManager.create.edit.catUnique";
	static CategoryManagerCreateTypeModalTitle = "categoryManager.create.type.modal.title";
	static CategoryManagerCreateCatModalTitle = "categoryManager.create.cat.modal.title";
	static CategoryManagerEditTypeModalTitle = "categoryManager.edit.type.modal.title";
	static CategoryManagerEditCatModalTitle = "categoryManager.edit.cat.modal.title";
	static CategoryManagerEditDisableTypeWarn = "categoryManager.edit.disable.type.warn";
	static CategoryManagerEditDisableCatWarn = "categoryManager.edit.disable.cat.warn";
	static CategoryManagerCreateTypeSuc = "categoryManager.create.type.success";
	static CategoryManagerCreateCatSuc = "categoryManager.create.cat.success";
	static CategoryManagerCreateTypeFail = "categoryManager.create.type.failed";
	static CategoryManagerCreateCatFail = "categoryManager.create.cat.failed";
	static CategoryManagerEditTypeSuc = "categoryManager.edit.type.success";
	static CategoryManagerEditCatSuc = "categoryManager.edit.cat.success";
	static CategoryManagerEditTypeFail = "categoryManager.edit.type.failed";
	static CategoryManagerEditCatFail = "categoryManager.edit.cat.failed";
	static CategoryManagerDelTypeSuc = "categoryManager.delete.type.success";
	static CategoryManagerDelCatSuc = "categoryManager.delete.cat.success";
	static CategoryManagerDelTypeFail = "categoryManager.delete.type.failed";
	static CategoryManagerDelCatFail = "categoryManager.delete.cat.failed";
	static CategoryManagerMoveDocSuc = "categoryManager.move.docs.suc";
	static CategoryManagerMoveDocFail = "categoryManager.move.docs.fail";
	static CategoryManagerFetchCountFail = "categoryManager.fetch.type.doc.count.fail";
	static CategoryManagerHeadingTxt = "categoryManager.heading.txt";
	static CategoryManagerAddNewCat = "categoryManager.cat.add.new";
	static CategoryManagerAddNewType = "categoryManager.type.add.new";
	static CategoryManagerCatDeleteConfirmMessage = "categoryManager.cat.delete.confirmmessage";
	static CategoryManagerTypeDeleteConfirmMessage = "categoryManager.type.delete.confirmmessage";
	static CategoryManagerBtnSave = "categoryManager.btn.save";
	static CategoryManagerBtnCancel = "categoryManager.btn.cancel";
	static CategoryManagerBtnDelete = "categoryManager.btn.delete";
	static CategoryManagerBtnMoveDelete = "categoryManager.btn.movedelete";
	static CategoryManagerLabelCat = "categoryManager.label.category";
	static CategoryManagerLabelDisCat = "categoryManager.label.disable.cat";
	static CategoryManagerLabelDisType = "categoryManager.label.disable.type";
	static CategoryManagerLabelSupportResources = "categoryManager.label.supportResources";
	static CategoryManagerLabelInter = "categoryManager.label.curriculumInternal";
	static CategoryManagerLabelShowOnContent = "categoryManager.label.showoncontentsite";
	static CategoryManagerDocCount = "categoryManager.del.type.doc.count";
	static CategoryManagerCatTypeCount = "categoryManager.del.cat.type.count";
	static CategoryManagerMoveDocChooseCat = "categoryManager.move.docs.choose.cat";
	static CategoryManagerMoveDocChooseType = "categoryManager.move.docs.choose.type";
	static CategoryManagerDocsCatPlaceHolder = "categoryManager.move.docs.cat.placeholder";
	static CategoryManagerDocsTypePlaceHolder = "categoryManager.move.docs.type.placeholder";
	static CategoryManagerContentGroupNone = "categoryManager.contentgroup.none";
	static CategoryManagerContentGroupSong = "categoryManager.contentgroup.song";
	static CategoryManagerContentGroupMovie = "categoryManager.contentgroup.movie";
	static CategoryManagerContentGroupStory = "categoryManager.contentgroup.story";
	static CategoryManagerContentGroupReader = "categoryManager.contentgroup.reader";
	static CategoryManagerContentGroupWriter = "categoryManager.contentgroup.writer";
	static CategoryManagerContentGroupVpc = "categoryManager.contentgroup.vpc";
	static CategoryManagerCurriculumLabel = "categoryManager.label.curriculum";
	static CategoryManagerAllowTeachingPlanLabel = "categoryManager.label.allowteachingplan";
	static CategoryManagerShowOnContentLabel = "categoryManager.label.showoncontent";
	static CategoryManagerUnitBasedLabel = "categoryManager.label.unitbased";
	static CategoryManagerManageLessonLabel = "categoryManager.label.managelesson";
	static CategoryManagerAllowRepPlanLabel = "categoryManager.label.allowrepplan";
	static CategoryManagerMultilingualMediaLabel = "categoryManager.label.multilingualmedia";
	static CategoryManagerShowLessonPlanLabel = "categoryManager.label.showlessonplanlabel";
	static CategoryManagerShowInLessonRelatedItemsLabel = "categoryManager.label.showinlessonrelateditems";
	static CategoryManagerContentGroupValidationMsg = "categorymanager.contentgroup.validationmsg";
	static CategoryManagerContentGroupLabel = "categorymanager.contentgroup.label";
	static CategoryManagerDeleteLessonPlanMsg = "categorymanager.category.deletelessonplanmsg";
	static CategoryManagerSubCategoryDeleteLessonPlanMsg = "categorymanager.subcategory.deletelessonplanmsg";
	static CategoryManagerDeleteLessonRelatedItemMsg = "categorymanager.subcategory.deleterelateditemmsg";
	static CategoryManagerDeleteLpAndRelatedItem = "categorymanager.subcategory.deletelpandrelateditems";
	static CategoryManagerMediaSlotNone = "categorymanager.mediaslot.none";
	static CategoryManagerDownloadMediaSlot = "categorymanager.downloadmediaslot.label";
	static CategoryManagerAssociateLessonPlan = "categorymanager.associatelessonplan.label";
	static CategoryManagerAssociateLessonPlanNone = "categorymanager.associatelessonplan.none";
	static CategoryManagerSupportResourcesLabel = "categoryManager.label.supportresources";
	static CategoryManagerErrorMessage = "categoryManager.error.message";
	static CategoryManagerSpecialDesignationNone = "categorymanager.subcategory.specialdesignation.none";
	static CategoryManagerSpecialDesignationVPC = "categorymanager.subcategory.specialdesignation.vpc";
	static CategoryManagerSpecialDesignationVPCReview = "categorymanager.subcategory.specialdesignation.vpcreview";
	static CategoryManagerSpecialDesignationLetterPhonogram =
		"categorymanager.subcategory.specialdesignation.letterphonogram";
	static CategoryManagerSpecialDesignationPhonogramWordCard =
		"categorymanager.subcategory.specialdesignation.phonogramwordcard";
	static CategoryManagerSpecialDesignationLabel = "categorymanager.specialdesignation.label";
	static CategoryManagerSpecialDesignationFocusWords = "categorymanager.subcategory.specialdesignation.focuswords";
	static CategoryManagerRemoveAssociationModalError = "categorymanager.removeassociation.modalerror";
	static CategoryManagerSubCategoryEditWarning = "categorymanager.subCategory.editWarning";
}

export class VcsLocale {
	static VersionGroupAddText = "versionGroup.add.text";
	static VersionGroupSelectGrapeseed = "versionGroup.add.selectGrapeseed";
	static VersionGroupSelectLittleSeed = "versionGroup.add.selectLittleseed";
	static VersionGroupExpandTitle = "versionGroup.expand.title";
	static VersionGroupSelectNone = "versionGroup.select.none";
	static VersionGroupAddNewTxt = "versionGroup.add.new.txt";
	static VersionGroupAddModalCrt = "versionGroup.add.modal.create";
	static VersionGroupAddModalCan = "versionGroup.add.modal.cancel";
	static VersionGroupAddNameLength = "versionGroup.add.name.length";
	static VersionGroupAddNameUnique = "versionGroup.add.name.unique";
	static VersionGroupAddChooseAtleatOne = "versionGroup.add.choose.atleast.one";
	static VersionGroupPubModalTitle = "versionGroup.pub.modal.title";
	static VersionGroupPubModalOk = "versionGroup.pub.modal.ok";
	static VersionGroupPubModalCancel = "versionGroup.pub.modal.cancel";
	static VersionGroupHeadGsSelected = "versionGroup.head.gsselected";
	static VersionGroupHeadLsSelected = "versionGroup.head.lsselected";
	static VersionGroupFormLabelGrapeseed = "versionGroup.form.label.grapeseed";
	static VersionGroupFormLabelLittleseed = "versionGroup.form.label.littleseed";
	static VersionGroupActionCreate = "versionGroup.action.create";
	static VersionGroupActionApply = "versionGroup.action.apply";
	static VersionGroupActionPublish = "versionGroup.action.publish";
	static VersionGroupPubModalInfo = "versionGroup.pub.modal.info";
	static VersionGroupPubModalGrapeseed = "versionGroup.pub.modal.grapeseed";
	static VersionGroupPubModalLittleseed = "versionGroup.pub.modal.littleseed";
	static VersionGroupPubModalSelectGrape = "versionGroup.pub.modal.select.grapeseed";
	static VersionGroupPubModalSelectLittle = "versionGroup.pub.modal.select.littleseed";
	static VersionGroupPubModalAlreadyGrape = "versionGroup.pub.modal.already.grape";
	static VersionGroupPubModalAlreadyLittle = "versionGroup.pub.modal.already.little";
	static VersionGroupGrapeCreateSuccess = "versionGroup.create.grape.success";
	static VersionGroupLittleCreateSuccess = "versionGroup.create.little.success";
	static VersionGroupBothCreateSuccess = "versionGroup.create.both.success";
	static VersionGroupCreateFail = "versionGroup.create.fail";
	static VersionGroupPubSuccess = "versionGroup.pub.success";
	static VersionGroupPubFail = "versionGroup.pub.fail";
	static VersionGroupCreateCopyInprogress = "versionGroup.createCopy.inprogress";
	static VersionGroupCreateCopyFailed = "versionGroup.createCopy.failed";
	static VersionGroupPublishCopyInprogress = "versionGroup.publishCopy.inprogress";
	static VersionGroupPublishCopyFailed = "versionGroup.publishCopy.failed";
	static VersionGroupApplyCopyInprogress = "versionGroup.applyCopy.inprogress";
	static VersionGroupApplyCopyFailed = "versionGroup.applyCopy.failed";
	static VersionGroupCopySuccess = "versionGroup.copy.success";
	static ObjectiveTextHasExisted = "objective.text.hasExisted";
	static ContentObjectiveNotSelectedTip = "contentObjective.notSelected.tip";
	static ObjectiveHasChildNodeTip = "objective.haschildnode.tip";
	static ObjectiveHasContentResourceTip = "objective.hascontentresource.tip";
	static ObjectiveCanDeleteTip = "objective.candelete.tip";
	static ObjectiveExpandLevel = "objective.expand.level";
	static ObjectiveAddNewObjectiveCategory = "objective.addNew.ObjectiveCategory";
	static ContentObjectiveExposureTitle = "contentobjective.exposure.title";
	static ContentObjectiveExposureWarning = "contentobjective.exposure.warning";
	static ContentObjectiveUnitTitle = "contentobjective.unit.title";
	static ContentObjectiveUnitWarning = "contentobjective.unit.warning";
}

export class CommonEntitiesLocale {
	static CommonActivitiesText = "common.activity.text";
	static CommonCountText = "common.count.text";
	static CommonRemoveText = "common.remove.text";
	static CommonAddActivityText = "common.addActivity.text";
	static CommonRemoveActivityText = "common.removeActivity.text";
	static CommonHasAssociatedDescriptionFirst = "common.hasAssociated.descriptionFirst";
	static CommonHasAssociatedDescriptionSecond = "common.hasAssociated.descriptionSecond";
	static CommonHasAssociatedDescriptionThird = "common.hasAssociated.descriptionThird";
	static CommonModalAddTransition = "common.modal.addTransition";
	static CommonModalTransition = "common.modal.transition";
	static CommonTansitionDescription = "common.transition.description";
	static CommonTansitionDuration = "common.transition.duration";
	static CommonEditActivity = "common.edit.activity";
	static CommonEditTansition = "common.edit.transition";
	static CommonTransitionName = "common.transition.name";
	static CommonRemoveTransition = "common.remove.transition";
	static CommonTransitionUsage = "common.transition.usage";
	static CommonExposureUsage = "common.exposure.usage";
	static CommonNoAssociatedDeleteActivity = "common.noAssociated.deleteActivity";
	static CommonNoAssociatedDeleteTransition = "common.noAssociated.deleteTransition";
	static CommonHasAssociatedLessonPlanDescrition = "common.hasAssociatedLessonPlan.description";
	static CommonTeachingActivityTextHasExisted = "common.teachingActivity.textHasExisted";
	static CommonTransitionTextHasExisted = "common.transition.textHasExisted";
	static CommonObjectivesText = "common.objectives.title";
	static CommonTransitionLessonPlanVersion = "common.transition.lessonPlanVersion";
	static CommonTransitionUnit = "common.transition.unit";
	static CommonTransitionLesson = "common.transition.lesson";
	static CommonTransitionCount = "common.transition.count";
	static CommonModalTransitionText = "common.modal.transitionText";
	static CommonModalAddNew = "common.modal.addNew";
	static CommonPageTitle = "common.page.Title";
}

export class ReportsLocale {
	static ReportsScopeSequenceTitle = "reports.scopeSequence.title";
	static ReportsShowObjectiveNumber = "reports.show.objectiveNumber";
	static ReportsYearText = "reports.year.text";
	static ReportsUnitsText = "reports.units.text";
	static ReportsShowObjectiveDetails = "reports.show.objectiveDetails";
	static ReportsShowLevel4Objectives = "report.show.level4Objectives";
	static ReportsFooterFirstColumnText = "reports.footer.firstColumnText";
	static ReportsFooterSecondColumnText = "reports.footer.secondColumnText";
	static ReportsFooterThirdColumnText = "reports.footer.thirdColumnText";
	static ReportsFooterFourthColumnText = "reports.footer.fourthColumnText";
	static ReportsExportText = "reports.export.text";
	static ReportsExportAllText = "reports.exportAll.text";
	static ReportsExportExcelText = "reports.export.excelText";
	static ReportsExportExcelTypeText = "reports.export.excelTypeText";
	static ReportsExportPdfTypeText = "reports.export.pdfTypeText";
	static ReportUnitText = "reports.unit.text";
	static ReportsComponentMethodology = "reports.component.methodology";
	static ReportsComponentText = "reports.component.text";
	static ReportsComponentSequence = "reports.component.sequence";
	static ReportsComponentRelatedItems = "reports.component.relatedItem";
	static ReportsComponentTeachingActivity = "reports.component.teachingActivity";
	static ReportsComponentObjective = "reports.component.objective";
	static ReportsLessonPlanVersionText = "reports.vpc.lessonplanVersion";
	static ReportsVPCText = "reports.vpc.text";
	static ReportsTotalText = "reports.total.text";
	static ReportsOverviewText = "reports.overview.text";
	static ReportsVocabularyText = "reports.vocabulary.text";
	static ReportsPhonogramsText = "reports.phonograms.text";
	static ReportsFocusText = "reports.focus.text";
	static ReportsReviewText = "reports.review.text";
	static ReportsLearningObjectivesText = "reports.learningObjectives.text";
	static ReportsPageTitle = "reports.page.title";
	static ReportsLPVText = "reports.lpv.text";
	static ReportsReviewVocabularyText = "reports.reviewvocabulary.text";
	static ReportsVPCReviewText = "reports.vpcreview.text";
	static ReportsObjectiveLevelSelectorText = "reports.objectiveLevelSelector.text";
	static ReportsObjectiveFilterText = "reports.objectiveFilter.text";
	static ReportsComponentObjectiveExportedFileName = "reports.componentObjective.exportedFileName";
	static ReportsMasteryQuestionObjectiveExportedFileName = "reports.masteryQuestionObjective.exportedFileName";
	static ReportsFocusWordChapterExportedFileName = "reports.focusWordChapter.exportedFileName";
	static ReportsMediaChangeImpactExportedFileName = "report.mediaChangeImpact.exportedFileName";
	static ReportsFocusWordsByChapterComponentLabelText = "reports.focusWordsByChapter.componentLabelText";
	static ReportsFocusWordsByChapterChapterLabelText = "reports.focusWordsByChapter.chapterLabelText";
	static ReportsFocusWordsByChapterFocusWordLabelText = "reports.focusWordsByChapter.focusWordLabelText";
	static ReportsFocusWordsByChapterAll = "reports.focusWordsByChapter.all";
	static ReportsFocusWordsByChapterSearch = "reports.focusWordsByChapter.search";
	static ReportsFocusWordsByChapterYes = "reports.focusWordsByChapter.yes";
	static ReportsFocusWordsByChapterNo = "reports.focusWordsByChapter.no";
	static ReportsFocusWordsByChapterFocusWordCol = "reports.focusWordsByChapter.focuswordcol";
	static ReportsFocusWordsByChapterFocusWordDefinitionCol = "reports.focusWordsByChapter.focusworddefcol";
	static ReportsFocusWordsByChapterFocusWordAudioCol = "reports.focusWordsByChapter.focuswordaudiocol";
	static ReportsFocusWordsByChapterDefAudioCol = "reports.focusWordsByChapter.definitionaudiocol";
	static ReportsFocusWordsByChapterImageCol = "reports.focusWordsByChapter.imagecol";
	static ReportsFocusWordsByChapterUnitFilter = "reports.focusWordsByChapter.unitfilter";
	static ReportsFocusWordsByChapterComponentFilter = "reports.focusWordsByChapter.componentfilter";
	static ReportsFocusWordsByChapterFilter = "reports.focusWordsByChapter.chapterfilter";
	static ReportsMediaChangeImpactNoDataExportExcelWarning = "reports.mediaChangeImpact.noData.exportExcel.warning";
}

export class PermissionManagerLocale {
	static PermissionManagerTitle = "permissionManager.title";
	static PermissionManagerContentLinkText = "permissionManager.contentLinkText";
	static PermissionManagerSelectUserText = "permissionManager.selectUserText";
	static PermissionManagerWordCountMenuText = "permissionManager.wordCountMenuText";
	static PermissionManagerWordManagerMenuText = "permissionManager.wordManagerMenuText";
	static PermissionManagerPhonogramManagerMenuText = "permissionManager.phonogramManagerMenuText";
	static PermissionManagerTextWriterMenuText = "permissionManager.textWriterMenuText";
	static PermissionManagerTextGuardianMenuText = "permissionManager.textGuardianMenuText";
	static PermissionManagerUserManagementMenuText = "permissionManager.userManagementMenuText";
	static PermissionManagerVersionManagementMenuText = "permissionManager.versionManagementMenuText";
	static PermissionManagerTemplatesMenuText = "permissionManager.templatesMenuText";
	static PermissionManagerMasterTemplatesMenuText = "permissionManager.masterTemplatesMenuText";
	static PermissionManagerSaveButton = "permissionManager.saveButton";
	static PermissionManagerNoPermissionText = "permissionManager.noPermissionText";
	static PermissionManagerNoUserErrorMsg = "permissionManager.noUserErrorMsg";
	static PermissionManagerNoPermissionErrorMsg = "permissionManager.noPermissionErrorMsg";
	static PermissionManagerSaveSuccessMsg = "permissionManager.saveSuccessMsg";
	static PermissionManagerTextAnalysisPermissionText = "permissionManager.textAnalysisPermissionText";
	static PermissionManagerReaderWriterPermissionText = "permissionManager.readerWriterPermissionText";
	static PermissionManagerWordManagerPermissionText = "permissionManager.wordManagerPermissionText";
	static PermissionManagerWordCountPermissionText = "permissionManager.wordCountPermissionText";
	static PermissionManagerTextChanageAnalysisPermissionText = "permissionManager.textChanageAnalysisPermissionText";
	static PermissionManagerTitleListMenuText = "permissionManager.titleListMenuText";
	static PermissionManagerTextListPermissionText = "permissionManager.textListPermissionText";
	static PermissionManagerSubtitlePermissionText = "permissionManager.subtitlePermissionText";
	static PermissionManagerComponentsPermissionText = "permissionManager.componentsPermissionText";
	static PermissionManagerTalkModePermissionText = "permissionManager.talkModePermissionText";
	static PermissionManagerLanguageFuncMenuText = "permissionManager.languageFuncMenuText";
	static PermissionManagerTagListPermissionText = "permissionManager.tagListPermissionText";
	static PermissionManagerTotalReportPermissionText = "permissionManager.totalReportPermissionText";
	static PermissionManagerDetailsReportPermissionText = "permissionManager.detailsReportPermissionText";
	static PermissionManagerLFSearchPermissionText = "permissionManager.lfSearchPermissionText";
	static PermissionManagerUnitListPermissionText = "permissionManager.unitListPermissionText";
	static PermissionManagerVocabListPermissionText = "permissionManager.vocabListPermissionText";
	static PermissionManagerPharseListPermissionText = "permissionManager.pharseListPermissionText";
	static PermissionManagerWordPharseTextPermissionText = "permissionManager.wordPhraseTextPermissionText";
	static PermissionManagerManageUserPermissionText = "permissionManager.manageUserPermissionText";
	static PermissionManagerContentAdminPermissionText = "permissionManager.contentAdminPermissionText";
	static PermissionManagerVersionManagementPermissionText = "permissionManager.versionManagementPermissionText";
	static PermissionManagerTitlePhraseListPermissionText = "permissionManager.titlePhraseListPermissionText";
	static PermissionManagerAssetListPermissionText = "permissionManager.assetlistPermissionText";
	static PermissionManagerCategoryManagerMenuText = "permissionManager.categoryManagerMenuText";
	static PermissionManagerCategoryManagerPermissionText = "permissionManager.categoryManagerPermissionText";
	static PermissionManagerWordSpecPermissionText = "permissionManager.wordSpecPermissionText";
	static PermissionManagerLessonPlanMenuText = "permissionManager.lessonPlanMenuText";
	static PermissionManagerLessonPlanVersionPermissionText = "permissionManager.lessonPlanVersionPermissionText";
	static PermissionManagerLessonPlanListPermissionText = "permissionManager.lessonPlanListPermissionText";
	static PermissionManagerFallbackText = "permissionManager.fallbackText";
	static PermissionManagerConversationsText = "permissionManager.conversationsText";
	static PermissionManagerOpenCloseText = "permissionManager.openCloseText";
	static PermissionManagerUtteranceEntitiesText = "permissionManager.utteranceEntitiesText";
	static PermissionManagerCommonIntentsText = "permissionManager.commonintents";
	static PermissionManagerComponentsMenuText = "permissionManager.ComponentsMenuText";
	static PermissionManagerNonCurriculumContentsMenuText = "permissionManager.NonCurriculumContentsMenuText";
	static PermissionManagerRevisionManagerMenuText = "permissionManager.RevisionManagerMenuText";
	static PermissionManagerText = "permissionManager.Text";
	static PermissionManagerObjectiveText = "permissionManager.ObjectiveText";
	static PermissionManagerTeachingPlanText = "permissionManager.TeachingPlanText";
	static PermissionManagerREPText = "permissionManager.RepText";
	static PermissionManagerManageChapterText = "permissionManager.ManageChapterText";
	static PermissionManagerObjectiveMenuText = "permissionManager.ObjectiveMenuText";
	static PermissionManagerCommonEntitiesMenuText = "permissionManager.CommonEntitiesMenuText";
	static PermissionManagerReportsMenuText = "permissionManager.ReportsMenuText";
	static PermissionManagerLPActivitiesMenuText = "permissionManager.LPActivitiesMenuText";
	static PermissionManagerConversationText = "permissionManager.ComponentConversation";
	static PermissionManagerWebsiteAdminText = "permissionManager.WebsiteAdmin";
	static PermissionManagerQrCodeManagerText = "permissionManager.QrCodeManager";
	static PermissionManagerMediaText = "permissionManager.Media";
	static PermissionManagerAccessLevelNone = "permissionManager.accessLevel.none";
	static PermissionManagerAccessLevelFull = "permissionManager.accessLevel.full";
	static PermissionManagerAccessLevelReadonly = "permissionManager.accessLevel.readonly";
	static PermissionManagerAccessLevelReadonlyExport = "permissionManager.accessLevel.readonlyExport";
	static PermissionManagerListManagement = "permissionManager.listManagement";
	static PermissionManagerCurriculumManagement = "permissionManager.curriculumManagement";
	static PermissionManagerLangFuncManagement = "permissionManager.languageFuncManagement";
	static PermissionManagerTextAnalysis = "permissionManager.textAnalysis";
	static PermissionManagerLessonPlanTemplate = "permissionManager.lessonPlanTemplate";
	static PermissionManagerTagList = "permissionManager.tagList";
	static PermissionManagerTagUsageStats = "permissionManager.tagUsageStats";
	static PermissionManagerTagUsageDetails = "permissionManager.tagUsageDetails";
	static PermissionManagerTagSearch = "permissionManager.tagSearch";
	static PermissionManagerNewTextAnalysis = "permissionManager.newTextAnalysis";
	static PermissionManagerReadWriteAnalysis = "permissionManager.readWriteAnalysis";
	static PermisisonManagerWordDetails = "permissionManager.wordDetails";
	static AppNavigationActiveLearn = "appNavigation.activelearn.title";
	static PermisisonManagerConversations = "template.tab.conversations";
	static PermisisonManagerStudentActivities = "appNavigation.lessonplanactivites";
	static PermissionManagerAuditHistoryText = "permissionManager.auditHistoryText";
	static PermissionManagerAuditHistory = "permissionManager.auditHistory";
}

export class ContentAdminLocale {
	static ContentAdminPageTitle = "contentAdmin.pageTitle";
	static ContentAdminInviteLink = "contentAdmin.inviteLink";
	static ContentAdminTableName = "contentAdmin.tableName";
	static ContentAdminTableEmail = "contentAdmin.tableEmail";
	static ContentAdminTableAction = "contentAdmin.tableAction";
	static ContentAdminDeleteTitle = "contentAdmin.deleteTitle";
	static ContentAdminRemoveTitle = "contentAdmin.removeTitle";
	static ContentAdminResendEmailTitle = "contentAdmin.resendEmailTitle";
	static ContentAdminDeleteConfirmation = "contentAdmin.deleteConfirmation";
	static ContentAdminInvitationDeleteConfirmation = "contentAdmin.invitation.deleteConfirmation";
	static ContentAdminDeleteSucessfulMessage = "contentAdmin.deleteSucessfulMessage";
	static ContentAdminInvitationDeleteSucessfulMessage = "contentAdmin.invitation.deleteSucessfulMessage";
	static ContentAdminResendSucessfulMessage = "contentAdmin.resendSucessfulMessage";
	static ContentAdminPermissionPageLinkText = "contentAdmin.permissionPageLinkText";

	static InvitationModalTitle = "contentAdmin.invitation.modal.title";
	static InvitationModalEmail = "contentAdmin.invitation.modal.email";
	static InvitationModalName = "contentAdmin.invitation.modal.name";
	static InvitationModalTemplate = "contentAdmin.invitation.modal.template";
	static InvitationModalEmailRequired = "contentAdmin.invitation.modal.email.required";
	static InvitationModalEmailMaxLength = "contentAdmin.invitation.modal.email.maxLength";
	static InvitationModalEmailInvalid = "contentAdmin.invitation.modal.email.invalid";
	static InvitationModalNameRequired = "contentAdmin.invitation.modal.name.required";
	static InvitationModalTemplateRequired = "contentAdmin.invitation.modal.template.required";

	static InvitationModalButtonInviteValidate = "contentAdmin.invitation.modal.btn.invite.validate";
	static InvitationModalButtonPreview = "contentAdmin.invitation.modal.btn.preview";
	static InvitationModalButtonClose = "contentAdmin.invitation.modal.btn.close";
	static InvitationModalButtonCancel = "contentAdmin.invitation.modal.btn.cancel";
	static InvitationModalButtonInviteSubmit = "contentAdmin.invitation.modal.btn.invite.submit";
	static InvitationModalButtonInviteSuccessfulMsg = "contentAdmin.invitation.modal.btn.invite.successful";
	static InvitationModalButtonInviteNotRegisteredMsg = "contentAdmin.invitation.modal.btn.invite.notregistered";
	static InvitationModalButtonInviteSuggestionText =
		"contentAdmin.invitation.modal.btn.invite.suggestionfornametemplate";
	static PreviewModalTitle = "contentAdmin.preview.modal.title";
}

export class GridLocale {
	static GirdExportExcelButton = "grid.exportExcel.button.text";
	static GirdExportPdfButton = "grid.exportPdf.button.text";
	static GridNoRecordFoundMessage = "grid.noRecord.message";
	static GridShowGroupPanelLinkText = "grid.showGroupPanel.linkText";
	static GridServiceFunctionError = "grid.serviceFunctionError";
}

export class WordPhraseSearchLocale {
	static WordPhraseSearchDescription = "wordPhraseSearch.description";
	static WordPhraseSearchUnitStartLabel = "wordPharseSearch.unitStartLabel";
	static WordPhraseSearchAllSkillText = "wordPharseSearch.allSkillLabel";
	static WordPhraseSearchUnitEndLabel = "wordPharseSearch.unitEndLabel";
	static WordPhraseSearchSkillLabel = "wordPharseSearch.skillLabel";
	static WordPhraseSearchTextSearchLabel = "wordPharseSearch.textSearchLabel";
	static WordPhraseSearchIsLemmaLabel = "wordPharseSearch.isLemmaLabel";
	static WordPhraseSearchDisplayButtonText = "wordPharseSearch.displayButtonText";
	static WordPhraseSearchLevelColumn = "wordPharseSearch.levelColumn";
	static WordPhraseSearchTitleColumn = "wordPharseSearch.titleColumn";
	static WordPhraseSearchVpcColumn = "wordPharseSearch.vpcColumn";
	static WordPhraseSearchSentenceColumn = "wordPharseSearch.sentenceColumn";
	static WordPhraseSearchInvalidParamsError = "wordPharseSearch.invalidParamsError";
	static WordPhraseSearchInputTextRequiredMessage = "wordPhraseSearch.inputTextRequiredMessage";
	static WordPhraseSearchPageTitle = "wordPhraseSearch.page.title";
}

export class TitleListLocale {
	static TitleListDescription = "titleList.description";
	static TitleListPageTitle = "titleList.pageTitle";
	static TitleListTableTitleColumn = "titleList.table.titleColumn";
	static TitleListTableCategoryColumn = "titleList.table.categoryColumn";
	static TitleListTableSubCategoryColumn = "titleList.table.subCategoryColumn";
	static TitleListTableLanguageSkillColumn = "titleList.table.languageSkillColumn";
	static TitleListTableTagEditionDateColumn = "titleList.table.tagEditionDateColumn";
	static TitleListLevelSelectLabel = "titleList.levelSelect.label";
	static TitleListLanguageSkillLabel = "titleList.languageSkill.label";
	static TitleListTableActionColumnRemoveTitle = "titleList.table.actionColumn.removeTitle";
	static TitleListRemoveTitleConfirmMessage = "titleList.removeTitleConfirmMessage";
	static TitleListRemoveTitleSuccessMessage = "titleList.removeTitleSuccessMessage";
	static TitleListLevelAll = "titleList.levelAll";
	static TitleListLanguageAll = "titleList.languageAll";
	static TitleListTableUnitColumn = "titleList.table.unitColumn";
	static TitleListCreateTitle = "titleList.create.title";
	static TitleListCreateTitleTxt = "titleList.create.title.txt";
	static TitleListCreateUnitTxt = "titleList.create.unit.txt";
	static TitleListCreateCategoryTxt = "titleList.create.category.txt";
	static TitleListCreateSubCatTxt = "titleList.create.subcategory.txt";
	static TitleListCreateSkillTxt = "titleList.create.skill.txt";
	static TitleListDupSuc = "titleList.duplicate.success";
	static TitleListDupFail = "titleList.duplicate.fail";
	static TitleListTagSearch = "titleList.tag.search";
	static TitleListDupRoot = "titleList.dup.rootVersion";
	static TitleListDupViewRoot = "titleList.dup.viewRoot";
	static TitleListDupThisVer = "titleList.dup.thisVersion";
	static TitleListCreateTag = "titleList.create.tag";
	static TitleListEditTitleSuc = "titleList.edit.title.suc";
	static TitleListEditTitleFail = "titleList.edit.title.fail";
	static TitleListCreateTitleSuc = "titleList.create.title.suc";
	static TitleListCreateTitleFail = "titleList.create.title.fail";
	static TitleListLeaveWarn = "titleList.leave.dirty.warn";
	static TitleListCompareName = "titleList.compare.name";
	static TitleListCompareVersion = "titleList.compare.version";
	static TitleListCompareCategory = "titleList.compare.category";
	static TitleListCompareSubCategory = "titleList.compare.subCategory";
	static TitleListCompareUnit = "titleList.compare.unit";
	static TitleListCompareSkill = "titleList.compare.skill";
	static TitleListCompareLoadFail = "titleList.compare.loadFail";
	static TitleListCompareComparing = "titleList.compare.comparing";
	static TitleListNoTag = "titleList.tag.noTag";
	static TitleListVersionCompare = "titleList.version.compare";
	static TitleListSelectVersion = "titleList.list.noVersion";
	static TitleListSaveTitle = "titleList.save.title";
	static TitleListAddNew = "titleList.create.new";
	static TitleListSaveAndUpdate = "titleList.create.save.update";
	static TitleListRevise = "titleList.create.revise";
	static TitleListCompareRevision = "titleList.compare.revision";
	static TitleListCreateRevision = "titleList.create.revision";
	static TitleListCompareNoDuplicate = "titleList.compare.noDuplicate";
	static TitleListConfirmMessageAddWords = "titleList.confirm.message.addWords";
	static TitleListConfirmBtnYes = "titleList.confirm.btn.yes";
	static TitleListConfirmBtnNo = "titleList.confirm.btn.no";
	static TitleListRemove = "titleList.remove";
	static TitleListCopy = "titleList.copy";
	static TitleListImport = "titleList.import";
	static TitleListExport = "titleList.export";
	static TitleListCopied = "titleList.copied";
	static TitleListRemoved = "titleList.removed";
	static TitleListExportPdfTitle = "titleList.export.pdfTitle";
	static TitleListNonCurriculumExportPdfTitle = "titleList.noncurriculum.export.pdfTitle";
	static TitleListExportExcelTitle = "titleList.export.excelTitle";
	static TitleListSeachButtonTxt = "titleList.search.btn.txt";
	static TitleListSearchLabel = "titleList.search.lable.txt";
	static TitleListExportSuccess = "titleList.export.success";
	static TitleListErrorOccurred = "titleList.error.occurred";
	static TitelListImportSuccess = "titleList.import.success";
	static TitelListImportNotChanged = "titleList.import.notChange";
	static TitleListInvalidTags = "titleList.invalid.tags";
	static TitleListDuplicateId = "titleList.duplicate.id";
	static TitleListMoreThanOneSheet = "titleList.morethanone.sheet";
	static TitleListNoSheet = "titleList.no.sheet";
	static TitleListInvalidData = "titleList.invalid.data";
	static TitleListSupportedFile = "titleList.import.supportedfile";
}

export class MethodologyLocale {
	static All = "methodology.title.all";
	static Classic = "methodology.title.classic";
	static Digital = "methodology.title.digital";
	static Remote = "methodology.title.remote";
	static Independent = "methodology.title.independent";
}

export class VocabularyListLocale {
	static VocabularyListPageTitle = "vocabularyList.pageTitle";
	static VocabularyListPageDescription = "vocabularyList.page.description";
	static VocabularyListLevelSelectLabel = "vocabularyList.levelSelect.label";
	static VocabularyListHeaderUnit = "vocabularyList.header.unit";
	static VocabularyListHeaderVocabulary = "vocabularyList.header.vocabulary";
	static VocabularyListMaxLevelAllowedMsg = "vocabularyList.levelSelect.max.error";
	static VocabularyListSearchPlaceholder = "vocabularyList.search.placeholder";
	static VocabularyManageDeleteConfirm = "vocabularyList.manage.delete.confirm";
	static VocabularyManageBtnAddNew = "vocabularyList.manage.btn.add";
	static VocabularyManageBtnBack = "vocabularyList.manage.btn.back";
	static VocabularyManageBtnSave = "vocabularyList.manage.btn.save";
	static VocabularyManagePendingChangesMsg = "vocabularyList.manage.pending.changes.warning";
	static VocabularyManageSaveSuccessfulMsg = "vocabularyList.manage.save.successfully";
	static VocabularyManageSaveErrorMsg = "vocabularyList.manage.save.error";
	static VocabularyManageNoDataMsg = "vocabularyList.manage.nodata";
	static VocabularyListPageAllOption = "vocabularyList.page.all.option";
}
export class UnitListLocale {
	static UnitListDescription = "unitList.description";
	static UnitListCreateNameRequired = "unitList.create.nameRequired";
	static UnitListCreateUnitNumberRequired = "unitList.create.unitNumberRequired";
	static UnitListCreateSuccessMessage = "unitList.create.successMessage";
	static UnitListCreateFailedMessage = "unitList.create.failedMessage";
	static UnitListEditSuccessMessage = "unitList.edit.successMessage";
	static UnitListEditFailedMessage = "unitList.edit.failedMessage";
	static UnitListValidationUniqueNameRequired = "unitList.validation.uniqueNameRequired";
	static UnitListValidationUniqueUnitNumberRequired = "unitList.validation.uniqueUnitNumberRequired";
	static UnitListDeleteErrorMessage = "unitList.delete.deleteErrorMessage";
	static UnitListDeleteSuccessMessage = "unitList.delete.deleteSuccessMessage";
	static UnitListDeleteWarningMessage = "unitList.delete.warningMessage";
	static UnitListDeleteWarningMessageObjective = "unitList.delete.warningMessageObjective";
	static UnitListDeleteConfirmMessage = "unitList.delete.confirmMessage";
	static UnitListCreateModalTitle = "unitList.create.ModalTitle";
	static UnitListEditModalTitle = "unitList.edit.ModalTitle";
	static UnitListFormUnitName = "unitList.form.unitName";
	static UnitListFormUnitNumber = "unitList.form.unitNumber";
	static UnitListGridHeaderUnit = "unitList.grid.header.unit";
	static UnitListGridHeaderSequence = "unitList.grid.header.sequence";
	static UnitListGridHeaderEnable = "unitList.grid.header.enable";
	static UnitListGridHeaderNoOfComponents = "unitList.grid.header.noOfComponents";
	static UnitListBtnSave = "unitList.btn.save";
	static UnitListBtnCancel = "unitList.btn.cancel";
	static UnitListBtnYes = "unitList.btn.yes";
	static UnitListBtnNo = "unitList.btn.no";
	static UnitListCreateUnitText = "unitList.create.text.newUnit";
	static UnitListGridIconTitleDelete = "unitList.grid.iconTitle.delete";
	static UnitListWarningDisableUnit = "unitList.warning.disableUnit";
	static UnitListWarningEnableUnit = "unitList.warning.enableUnit";
	static UnitListWarningPositiveValue = "unitList.warning.positiveValue";
	static UnitListWarningValueGreaterThanZero = "unitList.warning.valueGreaterThanZero";
	static UnitListWarningNumericValue = "unitList.warning.numericValue";
	static UnitListWarningUnitNameOverflow = "unitList.warning.unitNameOverflow";
	static UnitListWordAssociatedMsg = "unitList.association.word";
	static UnitListPageTitle = "unitList.pageTitle";
}
export class PhraseListLocale {
	static PhraseListPageTitle = "phraseList.pageTitle";
}

export class TitlePhraseListLocale {
	static TitlePhraseListAddButtonText = "titlePhraseList.addButtonText";
	static TitlePhraseListDuplicatePhraseMessage = "titlePhraseList.duplicatePhraseMessage";
	static TitlePhraseListSpecialCharatcerMessage = "titlePhraseList.specialCharacterMessage";
}
export class PhraseListComponentLocale {
	static PhraseListComponentTablePhraseColumn = "phraseListComponent.table.phraseColumn";
	static PhraseListComponentTableLemmaColumn = "phraseListComponent.table.lemmaColumn";
	static PhraseListComponentTableActionColumnRemoveTitle = "phraseListComponent.table.actionColumn.removeTitle";
	static PhraseListComponentTableActionColumnEditTitle = "phraseListComponent.table.actionColumn.editTitle";
	static PhraseListComponentCreateActionText = "phraseListComponent.createActionText";
	static PhraseListComponentDeleteSuccessMessage = "phraseListComponent.deleteSucessMessage";
	static PhraseListComponentDeleteConfirmMessage = "phraseListComponent.deleteConfirmMessage";
	static PhraseListComponentPharseIsLemmaValidation = "phraseListComponent.phraseIsLemma.Message";
}

export class PhraseListFormLocale {
	static PhraseListFormAddNewTitle = "phraseListForm.addNewTitle";
	static PhraseListFormEditTitle = "phraseListForm.editTitle";
	static PhraseListFormSaveButtonText = "phraseListForm.saveButtonText";
	static PhraseListFormCancelButtonText = "phraseListForm.cancelButtonText";
	static PhraseListFormWordLabel = "phraseListForm.wordLabel";
	static PhraseListFormWordRequiredMessage = "phraseListForm.wordRequiredMessage";
	static PhraseListFormLemmaHeading = "phraseListForm.lemmaHeading";
	static PhraseListFormAddLemmaText = "phraseListForm.addLemmaText";
	static PhraseListFormActionColumnRemoveTitle = "phraseListForm.removeLemmaTitle";
	static PhraseListFormWordRequiredValidationMessage = "phraseListForm.wordRequiredValidationMessage";
	static PhraseListFormWordUniqueValidationMessage = "phraseListForm.wordUniqueValidationMessage";
	static PhraseListFormLemmaDependencyMessage = "phraseListForm.lemmaDependencyMessage";
	static PhraseListFormSaveSuccessMessage = "phraseListForm.saveSuccessMessage";
}

export class LemmaSelectModalLocale {
	static LemmaSelectModalTitle = "lemmaSelectModal.title";
	static LemmaSelectModalSelectPlaceholder = "lemmaSelectModal.selectPlaceholder";
	static LemmaSelectModalSubmitButton = "lemmaSelectModal.submitButton";
	static LemmaSelectModalCancelButton = "lemmaSelectModal.cancelButton";
}

export class DetailsReportLocale {
	static DetailsReportLevelStartLabel = "detailsReport.levelStartLabel";
	static DetailsReportLevelEndLabel = "detailsReport.levelEndLabel";
	static DetailsReportSkillLabel = "detailsReport.skillLabel";
	static DetailsReportLanguageAll = "detailsReport.languageAll";
	static DetailsReportTableColumnCode = "detailsReport.tableColumn.code";
	static DetailsReportTableColumnDescription = "detailsReport.tableColumn.description";
	static DetailsReportTableColumnReferencedNumber = "detailsReport.tableColumn.referencedNumber";
	static DetailsReportTableColumnUnit = "detailsReport.tableColumn.unit";
	static DetailsReportTableColumnUnitName = "detailsReport.tableColumn.unitName";
	static DetailsReportTableColumnContentTitle = "detailsReport.tableColumn.contentTitle";
	static DetailsReportTableColumnCodeContentText = "detailsReport.tableColumn.codeContentText";
	static DetailsReportInvalidParamsError = "detailsReport.invalidParamsError";
	static DetailsReportPageTitle = "detailsReport.page.title";
	static DetailsReportExportTitle = "detailsReport.export.title";
}

export class TagListLocale {
	static TagListCreateNewTagText = "tagList.create.text.createNewTag";
	static TagListGridHeaderCode = "tagList.grid.header.code";
	static TagListGridHeaderDescription = "tagList.grid.header.description";
	static TagListGridHeaderCount = "tagList.grid.header.count";
	static TagListGridDeleteiconTitle = "tagList.grid.deleteIcon.title";
	static TagListModalCancelText = "tagList.modal.cancel.text";
	static TagListModalOkText = "tagList.modal.ok.text";
	static TagListModalTitleAddnewtag = "tagList.modal.title.addNewTag";
	static TagListModalTitleEdittag = "tagList.modal.title.editTag";
	static TagListConfirmModalTitleText = "tagList.confirm.modal.title.text";
	static TagListConfirmModalOkText = "tagList.confirm.modal.ok.text";
	static TagListConfirmModalCancelText = "tagList.confirm.modal.cancel.text";
	static TagListFormCodeLabel = "tagList.form.code.label";
	static TagListFormDescriptionLabel = "tagList.form.description.label";
	static TagListFormRulesCodeRequired = "tagList.form.rules.code.required";
	static TagListFormRulesCodeUnique = "tagList.form.rules.code.unique";
	static TagListFormRulesCodeFormat = "tagList.form.rules.code.format";
	static TagListAddTagSuccessMessage = "tagList.addTag.success.message";
	static TagListAddTagFailureMessage = "tagList.addTag.failure.message";
	static TagListEditTagSuccessMessage = "tagList.editTag.success.message";
	static TagListEditTagFailureMessage = "tagList.editTag.failure.message";
	static TagListDeleteTagWarningMessage = "tagList.deleteTag.warning.message";
	static TagListDeleteTagSuccessMessage = "tagList.deleteTag.success.message";
	static TagListDeleteTagFailureMessage = "tagList.deleteTag.failure.message";
	static TagListPageTitle = "taglist.page.title";
}

export class TotalReportLocale {
	static TotalReportLanguageSkillSelectLabel = "totalReport.languageSkill.select.label";
	static TotalReportLanguageSkillSelectAll = "totalReport.languageSkill.select.all";
	static TotalReportGridHeaderCode = "totalReport.grid.header.code";
	static TotalReportGridHeaderDescription = "totalReport.grid.header.description";
	static TotalReportGridHeaderTotal = "totalReport.grid.header.total";
	static TotalReportPageTitle = "totalReport.page.title";
	static TotalReportExportTitle = "totalReport.export.title";
}

export class WordCountLocale {
	static WordCountDescription = "wordCount.description";
	static WordCountTitleUnitStart = "wordCount.title.unitStart";
	static WordCountTitleUnitEnd = "wordCount.title.unitEnd";
	static WordCountTitleLanguageSkill = "wordCount.title.languageSkill";
	static WordCountTitleMaterialTitle = "wordCount.title.materialTitle";
	static WordCountActionDisplay = "wordCount.action.display";
	static WordCountGridHeaderWord = "wordCount.grid.header.word";
	static WordCountGridHeaderVPC = "wordCount.grid.header.vpc";
	static WordCountGridHeaderTotal = "wordCount.grid.header.total";
	static WordCountGridHeaderFirstLevel = "wordCount.grid.header.firstLevel";
	static WordCountGridHeaderGsFirstLevel = "wordCount.grid.header.gsfirstLevel";
	static WordCountGridHeaderLsFirstLevel = "wordCount.grid.header.lsfirstLevel";
	static WordCountLanguageSkillSelectAll = "wordCount.languageSkillSelect.all";
	static WordCountPageTitle = "wordCount.page.title";
}

export class WordCountTextAnalysisLocale {
	static WordCountTextAnalysisLocaleIntro = "wordCountTextAnalysis.intro";
	static WordCountTextAnalysisLocaleInputLabelUnit = "wordCountTextAnalysis.input.label.unit";
	static WordCountTextAnalysisLocaleInputLabelCompareWith = "wordCountTextAnalysis.input.label.compareWith";
	static WordCountTextAnalysisLocaleInputLabelLemma = "wordCountTextAnalysis.input.label.lemma";
	static WordCountTextAnalysisLocaleInputLabelText = "wordCountTextAnalysis.input.label.text";
	static WordCountTextAnalysisLocaleButtonSearch = "wordCountTextAnalysis.button.search";
	static WordCountTextAnalysisLocaleInputAll = "wordCountTextAnalysis.input.all";
	static WordCountTextAnalysisLocaleGridTitlePreviousUnit = "wordCountTextAnalysis.grid.title.previousUnit";
	static WordCountTextAnalysisLocaleGridTitleCurrentUnit = "wordCountTextAnalysis.grid.title.currentUnit";
	static WordCountTextAnalysisLocaleGridTitleFutureCurriculum = "wordCountTextAnalysis.grid.title.futureCurriculum";
	static WordCountTextAnalysisLocaleGridTitleNonCurriculum = "wordCountTextAnalysis.grid.title.nonCurriculum";
	static WordCountTextAnalysisLocaleGridColWord = "wordCountTextAnalysis.grid.col.word";
	static WordCountTextAnalysisLocaleGridColOccurences = "wordCountTextAnalysis.grid.col.occurences";
	static WordCountTextAnalysisLocaleGridColFirstUnit = "wordCountTextAnalysis.grid.col.firstUnit";
	static WordCountTextAnalysisLocaleGridColTotalOccurence = "wordCountTextAnalysis.grid.col.totalOccurence";
	static WordCountTextAnalysisLocaleGridColOccurence = "wordCountTextAnalysis.grid.col.occurence";
	static WordCountTextAnalysisLocaleGridColExposureLevel = "wordCountTextAnalysis.grid.col.exposureLevel";
	static WordCountTextAnalysisPageTitle = "wordCountTextAnalysis.page.title";
}
export class WordSpecLocale {
	static WordSpecDescription = "wordSpec.description";
	static WordSpecGridHeaderWord = "wordSpec.grid.header.word";
	static WordSpecGridHeaderPronunciation = "wordSpec.grid.header.pronunciation";
	static WordSpecGridHeaderPartofspeech = "wordSpec.grid.header.partOfSpeech";
	static WordSpecGridHeaderDefinition = "wordSpec.grid.header.definition";
	static WordSpecGridHeaderWordType = "wordSpec.grid.header.wordType";
	static WordSpecGridHeaderFirstUnitUsed = "wordSpec.grid.header.firstUnitUsed";
	static WordSpecGridHeaderLsFirstUsed = "wordSpec.grid.header.lsfirstUsed";
	static WordSpecGridHeaderGsFirstUsed = "wordSpec.grid.header.gsfirstUsed";
	static WordSpecGridHeaderTotalUsage = "wordSpec.grid.header.totalUsage";
	static WordSpecGridHeaderLemma = "wordSpec.grid.header.lemma";
	static WordSpecGridHeaderVPC = "wordSpec.grid.header.vpc";
	static WordSpecButtonDisplay = "wordSpec.button.display";
	static WordSpecPageTitle = "wordSpec.page.title";
	static WordSpecExportTitle = "wordSpec.export.title";
}

export class TextChangeAnalysisLocale {
	static AnalysisDescriptionText = "textchangeanalysis.description.text";
	static AnalysisLabelUnit = "textchangeanalysis.label.unit";
	static AnalysisLabelUnitStart = "textchangeanalysis.label.unitstart";
	static AnalysisLabelUnitEnd = "textchangeanalysis.label.unitend";
	static AnalysisLabelMaterial = "textchangeanalysis.label.material";
	static AnalysisLabelRevisedText = "textchangeanalysis.label.revisedtext";
	static AnalysisLabelOptions = "textchangeanalysis.label.options";
	static AnalysisLabelCurrentText = "textchangeanalysis.label.currenttext";
	static AnalysisLabelRevisedTextOption = "textchangeanalysis.label.revisedtextoption";
	static AnalysisLabelChangedWords = "textchangeanalysis.label.changedwords";
	static AnalysisWordCount = "textchangeanalysis.wordcount";
	static AnalysisLabelDifference = "textchangeanalysis.difference";
	static AnalysisColumnWords = "textchangeanalysis.column.words";
	static AnalysisColumnVpc = "textchangeanalysis.column.vpc";
	static AnalysisColumnCurrent = "textchangeanalysis.column.current";
	static AnalysisColumnRevision = "textchangeanalysis.column.revision";
	static AnalysisColumnDifference = "textchangeanalysis.column.difference";
	static AnalysisColumnTotal = "textchangeanalysis.column.total";
	static AnalysisDisplay = "textchangeanalysis.text.display";
	static AnalysisChangedWords = "textchangeanalysis.text.changedwords";
	static AnalysisResult = "textchangeanalysis.text.result";
	static AnalysisNoMaterialText = "textchangeanalysis.material.nodata";
	static AnalysisRevisedTextValidation = "textchangeanalysis.revisedtext.validation";
	static AnalysisSelectedMaterialValidation = "textchangeanalysis.selectedmaterial.validation";
	static AnalysisExportFileName = "textchangeanalysis.export.filename";
	static AnalysisNoChangedWordsMsg = "textchangeanalysis.text.nowordschange";
	static AnalysisPageTitle = "textchangeanalysis.page.title";
}

export class ReadWriteTextAnalysisLocale {
	static ReadWriteNoGSVersionMsg = "rwtextanalysis.nogsversiongroup.msg";
	static ReadWritePageTitle = "rwtextanalysis.page.title";
	static ReadWritePageDescription = "rwtextanalysis.page.description";
}

export class LFSearchReportLocale {
	static LFSearchReportLabelInputLFCode = "lfSearchReport.label.input.lfCode";
	static LFSearchReportMessageNoTagFound = "lfSearchReport.message.noTagFound";
	static LFSearchReportButtonSearch = "lfSearchReport.button.search";
	static LFSearchReportGridHeaderUnit = "lfSearchReport.grid.header.unit";
	static LFSearchReportGridHeaderTitle = "lfSearchReport.grid.header.title";
	static LFSearchReportGridHeaderSentences = "lfSearchReport.grid.header.sentences";
	static LFSearchReportSelectPlaceholder = "lfSearchReport.select.placeholder";
	static LFSearchReportPageTitle = "lfSearchReport.page.title";
	static LFSearchReportExportTitle = "lfSearchReport.export.title";
}

export class LessonPlanLocale {
	static LessonPlanVersionPageTitle = "lessonplan.version.pagetitle";
	static LessonPlanVersionMethodologyTitle = "lessonplan.version.methodologytitle";
	static LessonPlanVersionAddButtonText = "lessonplan.version.addbuttontext";
	static LessonPlanVersionColumnVersionGroupTitle = "lessonplan.version.columnversiongrouptitle";
	static LessonPlanVersionColumnVersionTitle = "lessonplan.version.columnversiontitle";
	static LessonPlanVersionColumnMethodologyTitle = "lessonplan.version.columnmethodologytitle";
	static LessonPlanVersionColumnDescriptionTitle = "lessonplan.version.columndescriptiontitle";
	static LessonPlanVersionColumnStatusTitle = "lessonplan.version.columnstatustitle";
	static LessonPlanVersionStatusDraftText = "lessonplan.version.statusdrafttext";
	static LessonPlanVersionStatusPublishedText = "lessonplan.version.statuspublishedtext";
	static LessonPlanVersionPublishActionTitle = "lessonplan.version.publishactiontitle";
	static LessonPlanVersionPublishPromptMessage = "lessonplan.version.publishpromptmessage";
	static LessonPlanVersionSetInternalPromptMessage = "lessonplan.version.setinternalpromptmessage";
	static LessonPlanVersionPublishREPPromptMessage = "lessonplan.version.publishREPpromptmessage";
	static LessonPlanVersionUnpublishActionTitle = "lessonplan.version.unpublishactiontitle";
	static LessonPlanVersionUnpublishPromptMessage = "lessonplan.version.unpublishpromptmessage";
	static LessonPlanVersionInternalRevertPromptMessage = "lessonplan.version.internalrevertpromptmessage";
	static LessonPlanVersionRegionStatusErrorMessage = "lessonplan.version.statuserrormessgae";
	static LessonPlanVersionContentTypeStatusErrorMessage = "lessonplan.version.contenttype.statuserrormessgae";
	static LessonPlanVersionAddFormTitle = "lessonplan.version.addformtitle";
	static LessonPlanVersionEditFormTitle = "lessonplan.version.editformtitle";
	static LessonPlanVersionDuplicateFormTitle = "lessonplan.version.duplicateformtitle";
	static LessonPlanVersionFieldMethodologyTitle = "lessonplan.version.fieldmethodologytitle";
	static LessonPlanVersionFieldNameTitle = "lessonplan.version.fieldnametitle";
	static LessonPlanVersionFieldNamePlaceHolder = "lessonplan.version.fieldnameplaceholder";
	static LessonPlanVersionFieldDescriptionTitle = "lessonplan.version.fielddescriptiontitle";
	static LessonPlanVersionNameRequireMessage = "lessonplan.version.namerequiremessage";
	static LessonPlanVersionNameOverflowMessage = "lessonplan.version.nameoverflowmessage";
	static LessonPlanVersionNameExistsMessage = "lessonplan.version.nameexistsmessage";
	static LessonPlanVersionDescriptionOverflowMessage = "lessonplan.version.descriptionoverflowmessage";
	static LessonPlanVersionDeletePromptMessage = "lessonplan.version.deletepromptmessage";
	static LessonPlanVersionDraftStatus = "lessonplan.version.draftstatus";
	static LessonPlanVersionInternalStatus = "lessonplan.version.internalstatus";
	static LessonPlanVersionPublihStatus = "lessonplan.version.publishstatus";

	static LessonPlanListPageTitle = "lessonplan.list.pagetitle";
	static LessonPlanListLessonPlanVersionTitle = "lessonplan.list.lessonplanversiontitle";
	static LessonPlanListUnitTitle = "lessonplan.list.unittitle";
	static LessonPlanListLessonPlansTitle = "lessonplan.list.lessonplanstitle";
	static LessonPlanListAddButtonText = "lessonplan.list.addbuttontext";
	static LessonPlanListMasterPlanButtonText = "lessonplan.list.masterplanbuttontext";
	static LessonPlanListColumnNameTitle = "lessonplan.list.columnnametitle";
	static LessonPlanListColumnSequenceTitle = "lessonplan.list.columnsequencetitle";
	static LessonPlanListColumnEstimatedTimeTitle = "lessonplan.list.columnestimatedtimetitle";
	static LessonPlanListMoveUpTitle = "lessonplan.list.moveuptitle";
	static LessonPlanListMoveDownTitle = "lessonplan.list.movedowntitle";
	static LessonPlanDeletePromptMessage = "lessonplan.list.deletepromptmessage";
	static LessonPlanListMasterConversationPlanText = "lessonplan.list.masterconversationplan";
	static LessonPlanExposureConversationTitle = "lessonplan.list.exposureconversationtitle";
	static LessonPlanListAddLessonCountRequiredMsg = "lessonplan.list.lessonCountRequired";
	static LessonPlanListAddLessonCountLabelText = "lessonplan.list.lessonCountLabelText";
	static LessonPlanListAddLessonCountErrorText = "lessonplan.list.lessonCountErrorText";
	static LessonPlanListAddPlaylistCountLabelText = "lessonplan.list.playlistCountLabelText";
	static LessonPlanListAddModalSave = "lessonplan.modal.save";
	static LessonPlanListAddModalCancel = "lessonplan.list.cancel";
	static LessonPlanListPlaylists = "lessonplan.lessonPlanList.playlists";
	static LessonPlanListPlaylistEditor = "lessonplan.lessonPlanList.playlistEditor";
	static LessonPlanListTargetLPText = "lessonplan.lessonPlanList.targetlptext";
	static LessonPlanListCopySuccessMsg = "lessonplan.lessonPlanList.copysuccessmsg";
	static LessonPlanListCopyFailMsg = "lessonplan.lessonPlanList.copyfailmsg";
	static LessonPlanListCopyWarningMsg = "lessonplan.lessonPlanList.copywarningmsg";

	static LessonPlanPlayListBuilderPageTitle = "lessonplan.playlistbuilder.pagetitle";
	static LessonPlanPlayListBuilderLessonPlanVersionLabelTitle =
		"lessonplan.playlistbuilder.lessonplanversionlabeltitle";
	static LessonPlanPlayListBuilderAddButtonTitle = "lessonplan.playlistbuilder.addbuttontitle";
	static LessonPlanPlayListBuilderCellQuestionTitle = "lessonplan.playlistbuilder.cell.questiontitle";
	static LessonPlanPlayListBuilderCellConversationTitle = "lessonplan.playlistbuilder.cell.conversationtitle";
	static LessonPlanPlayListBuilderCellItemsTitle = "lessonplan.playlistbuilder.cell.itemstitle";
	static LessonPlanPlayListAddModalTitle = "lessonplan.playlist.addModalTitle";
	static LessonPlanAddModalTitle = "lessonplan.addModal.title";

	static LessonPlanMasterPlanPageTitle = "lessonplan.masterplan.pagetitle";
	static LessonPlanMasterPlanUnitLabelTitle = "lessonplan.masterplan.unitlabeltitle";
	static LessonPlanMasterPlanMethodologyLabelTitle = "lessonplan.masterplan.methodologylabeltitle";
	static LessonPlanMasterPlanLessonPlanVersionLabelTitle = "lessonplan.masterplan.lessonplanversionlabeltitle";
	static LessonPlanMasterPlanAddLessonButtonTitle = "lessonplan.masterplan.addlessonbuttontitle";
	static LessonPlanMasterPlanCopyLessonButtonTitle = "lessonplan.masterplan.copylessonbuttontitle";
	static LessonPlanMasterPlanClearButtonTitle = "lessonplan.masterplan.clearbuttontitle";
	static LessonPlanMasterPlanBackButtonTitle = "lessonplan.masterplan.backbuttontitle";
	static LessonPlanMasterPlanColumnComponentTitle = "lessonplan.masterplan.column.componenttitle";
	static LessonPlanMasterPlanColumnExposureTitle = "lessonplan.masterplan.column.exposuretitle";
	static LessonPlanMasterPlanCellEstimatedTimeTitle = "lessonplan.masterplan.cell.estimatetimetitle";
	static LessonPlanMasterPlanCellTransitionTitle = "lessonplan.masterplan.cell.transitiontitle";
	static LessonPlanMasterPlanTaughtNormatDescription = "lessonplan.masterplan.taughtnormaldescription";
	static LessonPlanMasterPlanTaughtOptionalDescription = "lessonplan.masterplan.taughtoptionaldescription";
	static LessonPlanMasterPlanManageTransitionTitle = "lessonplan.masterplan.managetransitiontitle";
	static LessonPlanMasterPlanManageQuestionTitle = "lessonplan.masterplan.managequestiontitle";
	static LessonPlanMasterPlanManageItemsTitle = "lessonplan.masterplan.manageitemstitle";
	static LessonPlanMasterPlanManageActivitiesTitle = "lessonplan.masterplan.manageactivitiestitle";
	static LessonPlanMasterPlanManageTransitionSubTitle = "lessonplan.masterplan.managetransitionsubtitle";
	static LessonPlanMasterPlanManageTransitionCustomTitle = "lessonplan.masterplan.managetransitioncustomtitle";
	static LessonPlanMasterPlanManageConversationCustomTitle = "lessonplan.masterplan.manageconversationcustomtitle";
	static LessonPlanMasterPlanManageConversationAddButtonText =
		"lessonplan.masterplan.manageconversationaddbuttontext";
	static LessonPlanMasterPlanManageConversationTestUXButtonText =
		"lessonplan.masterplan.manageconversationtestuxbuttontext";
	static LessonPlanMasterPlanManageTransitionAddButtonText = "lessonplan.masterplan.managetransitionaddbuttontext";
	static LessonPlanMasterPlanManageQuestionAddButtonText = "lessonplan.masterplan.managequestionaddbuttontext";
	static LessonPlanMasterPlanManageActivityAddButtonText = "lessonplan.masterplan.manageactivityaddbuttontext";
	static LessonPlanMasterPlanManageQuestionRadioText = "lessonplan.masterplan.managequestionradiotext";
	static LessonPlanMasterPlanManageConversationRadioText = "lessonplan.masterplan.manageconversationradiotext";
	static LessonPlanMasterPlanManageConversationSelectRequiredMessage =
		"lessonplan.masterplan.manageconversationselectrequiredmessage";
	static LessonPlanMasterPlanManageConversationSelectCorrectMessage =
		"lessonplan.masterplan.manageconversationselectcorrectmessage";
	static LessonPlanMasterPlanManageTransitionListColumnItemTitle =
		"lessonplan.masterplan.managetransitionlistcolumnitemtitle";
	static LessonPlanMasterPlanManageTransitionListColumnPositionTitle =
		"lessonplan.masterplan.managetransitionlistcolumnpositiontitle";
	static LessonPlanMasterPlanManageTransitionListColumnActionTitle =
		"lessonplan.masterplan.managetransitionlistcolumnremovetitle";
	static LessonPlanMasterPlanManageTransitionListDeletePromptMessage =
		"lessonplan.masterplan.managetransitionlistdeletepromptmessage";

	static LessonPlanMasterPlanManageQuestionListDeletePromptMessage =
		"lessonplan.masterplan.managequestionlistdeletepromptmessage";
	static LessonPlanMasterPlanManageConversationListDeletePromptMessage =
		"lessonplan.masterplan.manageconversationlistdeletepromptmessage";

	static LessonPlanMasterPlanLessonPlanEditorPageTitle = "lessonplan.masterplanlessonplaneditor.pagetitle";
	static LessonPlanMasterPlanLessonPlanEditorLessonLabelTitle =
		"lessonplan.masterplanlessonplaneditor.lessonlabeltitle";
	static LessonPlanMasterPlanLessonPlanEditorColumnComponent =
		"lessonplan.masterplanlessonplaneditor.columncomponent";
	static LessonPlanMasterPlanLessonPlanEditorVPCNeededTitle = "lessonplan.masterplanlessonplaneditor.vpcneededtitle";
	static LessonPlanMasterPlanWarningSwitch = "lessonplan.masterplan.warning.switch";

	static LessonPlanTemplatePageTitle = "lessonplan.template.pagetitle";
	static LessonPlanTemplateDownloadStandartTemplateTitle = "lessonplan.template.downloadstandardtemplatetitle";
	static LessonPlanTemplateColumnDefaultTitle = "lessonplan.template.column.defaulttitle";
	static LessonPlanTemplateColumnNameTitle = "lessonplan.template.column.nametitle";
	static LessonPlanTemplateColumnMethodologyTitle = "lessonplan.template.column.methodologytitle";
	static LessonPlanTemplateColumnDeleteTitle = "lessonplan.template.column.deletetitle";
	static LessonPlanTemplateDeletePromptMessage = "lessonplan.template.deletepromptmessage";

	static LessonPlanTemplateAddFormTitle = "lessonplan.templateedit.addformtitle";
	static LessonPlanTemplateEditFormTitle = "lessonplan.templateedit.editformtitle";
	static LessonPlanTemplateEditFieldNameTitle = "lessonplan.templateedit.fieldnametitle";
	static LessonPlanTemplateEditFieldNamePlaceHolder = "lessonplan.templateedit.fieldnameplaceholder";
	static LessonPlanTemplateEditNameRequireMessage = "lessonplan.templateedit.namerequiremessage";
	static LessonPlanTemplateEditFieldMethodologyTitle = "lessonplan.templateedit.methodologytitle";
	static LessonPlanTemplateEditFieldMethodologyPlaceHolder = "lessonplan.templateedit.methodologyplaceholder";
	static LessonPlanTemplateEditMethodologyRequireMessage = "lessonplan.templateedit.methodologyrequiremessage";
	static LessonPlanTemplateEditFieldDefaultTitle = "lessonplan.templateedit.defaulttitle";
	static LessonPlanTemplateEditTemplateFileTitle = "lessonplan.templateedit.templatefiletitle";
	static LessonPlanTemplateEditTemplateFileRequireMessage = "lessonplan.templateedit.templatefilerequiremessage";
	static LessonPlanTemplateEditSelectFileText = "lessonplan.templateedit.selectfiletext";
	static LessonPlanTemplateEditRowsTitle = "lessonplan.templateedit.rowstitle";
	static LessonPlanTemplateEditHeaderRowsText = "lessonplan.templateedit.headerrowstext";
	static LessonPlanTemplateEditHeaderRowsPlaceHolder = "lessonplan.templateedit.headerrowsplaceholder";
	static LessonPlanTemplateEditTeachingPlanRowsText = "lessonplan.templateedit.teachingplanrowstext";
	static LessonPlanTemplateEditTeachingPlanRowsPlaceHolder = "lessonplan.templateedit.teachingplanrowsplaceholder";
	static LessonPlanTemplateEditTeachingPlanRowsRequireMessage =
		"lessonplan.templateedit.teachingplanrowsrequiremessage";
	static LessonPlanTemplateEditTransitionRowsText = "lessonplan.templateedit.transitionrowstext";
	static LessonPlanTemplateEditTransitionRowsPlaceHolder = "lessonplan.templateedit.transitionrowsplaceholder";
	static LessonPlanTemplateEditTransitionRowsRequireMessage = "lessonplan.templateedit.transitionrowsrequiremessage";
	static LessonPlanTemplateEditTemplateRowsFormatMessage = "lessonplan.templateedit.templaterowsformatmessage";
	static LessonPlanTemplateEditTemplateRowsConflitMessage = "lessonplan.templateedit.templaterowsconflictmessage";
	static LessonPlanTemplateEditTemplateRowsOverflowMessage = "lessonplan.templateedit.templaterowsoverflowmessage";
	static LessonPlanTemplateDownloadTitle = "lessonplan.template.downloadtitle";

	static LessonPlanFrontMatterTitle = "lessonplan.frontmatter.title";
	static FrontMatterRemoveConfirmMessage = "frontmatter.removeconfirmmessage";
	static FrontMatterFileSizeError = "frontmatter.filesize.error";
	static FrontMatterFileTypeError = "frontmatter.filetype.error";
	static FrontMatterDownloadStartedMessage = "frontmatter.downloadstarted.message";
	static FrontMatterDownloadSuccessMessage = "frontmatter.downloadsuccess.message";
	static FrontMatterDownloadFailureMessage = "frontmatter.downloadfailure.message";
	static FrontMatterUploadSuccessMessage = "frontmatter.uploadsuccess.message";
	static FrontMatterUploadFailedMessage = "frontmatter.uploadfailed.message";
	static FrontMatterDeleteSuccessMessage = "frontmatter.deletesuccess.message";
	static FrontMatterDeleteFailureMessage = "frontmatter.deletefailure.message";
	static SwitchModalTitle = "masterplan.switchmodal.title";
}

export class CommonFormLocale {
	static ComponentChangeToParentConfirmMsg = "component.changetoparent.confirmmsg";
	static CommonMessageIsParent = "common.message.is.parent";
	static CommonMessageIsParentRelatedPlaylist = "common.message.is.parent.related.playlist";
	static CommonMessageIsParentConfirmOnChanging = "common.message.is.parent.confirm.onchanging";
	static CommonMessageIsParentConfirmText = "common.message.is.parent.confirm.text";
	static CommonMessageIsParentConfirmMedia = "common.message.is.parent.confirm.media";
	static CommonMessageIsParentConfirmREPPlan = "common.message.is.parent.confirm.repplan";
	static CommonMessageIsParentConfirmConversation = "common.message.is.parent.confirm.conversation";
	static CommonMessageIsParentConfirmAreYouSure = "common.message.is.parent.confirm.areyousure";
	static CommonMessageIsContentInfoConfirmAreYouSure = "common.message.is.contentinfo.confirm.areyousure";
	static CommonMessageIsContentInfoConfirmRemoveAreYouSure = "common.message.is.contentinfo.confirm.removeareyousure";
}

export class ManageChapterLocale {
	static ManageChapterLinkTitleConfirmMsg = "managechapter.linktitle.confirmmsg";
	static MangageChapterUnlinkFailedMsg = "managechapter.unlink.failedmsg";
	static MangageChapterUnlinkTitleMsg = "managechapter.unlink.titlemsg";
	static MangageChapterUnlinkChapterSuccessMsg = "managechapter.unlink.chapter.successmsg";
	static MangageChapterUnlinkChapterFailedMsg = "managechapter.unlink.chapter.failedmsg";
}

export class ContentExposureLocale {
	static ContentExposureAddExposureIndex = "contentexposure.action.addexposureindex";
	static ContentExposureAddDuplicateExposure = "contentexposure.action.addduplicateexposure";
	static ContentExposureMethologySelect = "contentexposure.methology.select";
	static ContentExposureLPVSelect = "contentexposure.lpv.select";
	static ContentExposureAddExposureRadio = "contentexposure.action.addexposureradio";
	static ContentExposureDuplicateExposureRadio = "contentexposure.action.duplicateexposureradio";
	static ContentExposureDuplicateExposureWarning = "contentexposure.action.duplicateexposurewarning";
	static ContentExposureAddExposureTitle = "contentexposure.addexposure.title";
	static ContentExposureAddExposureOkButtonText = "contentexposure.addexposure.okbuttontext";
	static ContentExposureAddExposureCancelButtonText = "contentexposure.addexposure.cancelbuttontext";
	static ContentExposureAddExposureNumberofExposure = "contentexposure.addexposure.numberofexposure";
	static ContentExposureAddExposureRequiredNumberofExposure = "contentexposure.addexposure.requiredexposuremessage";
	static ContentExposureAddExposureMinMaxRequiredNumberofExposure =
		"contentexposure.addexposure.minmaxrequiredexposuremessage";
	static ContentExposureWarningDelete = "contentexposure.warning.delete";
	static ContentExposureWarningDurationRange = "contentexposure.warning.durationrange";
	static ContentExposureWarningMethodologyEmpty = "contentexposure.warning.methodologyempty";
	static ContentExposureWarningMethodologyUpperLimit = "contentexposure.warning.methodologyupperlimit";
	static ContentExposureWarningAttachLessonPlan = "contentexposure.warning.attachlessonplan";
	static ContentExposureWarningAttachLessonPlanSlot = "contentexposure.warning.attachlessonplanslot";
	static ContentExposureTitle = "contentexposure.title.teachingplan";
	static ContentExposureDuration = "contentexposure.title.duration";
	static ContentExposureMethodology = "contentexposure.title.methodology";
	static ContentExposureRelatedItems = "contentexposure.title.relateditems";
	static ContentExposureTeachingActivity = "contentexposure.title.teachingactivity";
	static ContentExposureObjective = "contentexposure.title.objective";
	static ContentExposureAction = "contentexposure.title.action";
	static ContentExposureRelatedItemsSequence = "contentexposure.relateditems.sequence";
	static ContentExposureRelatedItemsType = "contentexposure.relateditems.type";
	static ContentExposureRelatedItemsItem = "contentexposure.relateditems.item";
	static ContentExposureRelatedItemsUnit = "contentexposure.relateditems.unit";
	static ContentExposureRelatedItemsAddNew = "contentexposure.relateditems.addnew";
	static ContentExposureRelatedItemsAddNewBtn = "contentexposure.relateditems.addnewbtn";
	static ContentExposureRelatedItemsFieldExisted = "contentexposure.relateditems.fieldexisted";
	static ContentExposureRelatedItemsFieldLength = "contentexposure.relateditems.fieldlength";
	static ContentExposureRelatedItemsOtherVpcs = "contentexposure.relateditems.otherVpcs";
	static ContentExposureRelatedItemsLabelChapters = "contentexposure.relateditems.label.chapters";
	static ContentExposureRelatedItemsConfirmCancelMsg = "contentexposure.relateditems.confirmcancelmsg";
	static ContentExposureRelatedItemVpcLabel = "contentexposure.relateditem.vpclabel";
	static ContentExposureRelatedItemSubCategory = "contentexposure.relateditem.subcategory";
	static ContentExposureRelatedItemOther = "contentexposure.relateditem.other";
	static ContentExposureRelatedItemChapterReferenceWarning = "contentexposure.relateditem.chapterreferencewarning";
	static ContentExposureTeachingActivitiesTitle = "contentexposure.teachingActivities.title";
	static ContentExposureTeachingActivitiesAdd = "contentexposure.teachingActivities.add";
	static ContentExposureTeachingActivitiesAddNewActivity = "contentexposure.teachingActivities.addNewActivity";
	static ContentExposureTeachingActivitiesSequence = "contentexposure.teachingActivities.sequence";
	static ContentExposureTeachingActivitiesPosition = "contentexposure.teachingActivities.position";
	static ContentExposureTeachingActivitiesRemove = "contentexposure.teachingActivities.remove";
	static ContentExposureTeachingActivitiesObjectiveTitle = "contentexposure.teachingActivities.objectivetitle";
	static ContentExposureTeachingActivitiesObjectiveLink = "contentexposure.teachingActivities.objectivelink";
	static ContentExposureTeachingActivitiesObjectiveUpdate = "contentexposure.teachingActivities.objectiveupdate";
	static ContentExposureTeachingActivityHasSelected = "contentexposure.teachingActivity.hasSelected";
	static ContentExposureTeachingActivitiesActivity = "contentexposure.teachingActivities.activityname";
	static ContentExposureTeachingActivitiesOrder = "contentexposure.teachingActivities.order";
	static ContentExposureTeachingActivitiesEdit = "contentexposure.teachingActivities.edit";
	static ContentExposureTeachingActivitiesImage = "contentexposure.teachingActivities.image";
	static ContentExposureTeachingActivitiesMastery = "contentexposure.teachingActivities.mastery";
	static ContentExposureTeachingActivitiesTips = "contentexposure.teachingActivities.tips";
	static ContentExposureTeachingActivitiesImageSubmit = "contentexposure.teachingActivities.imagesubmit";
	static ContentExposureTeachingActivitiesImageCancel = "contentexposure.teachingActivities.imagecancel";
	static ContentExposureConversationAddTitle = "contentexposure.conversation.addTitle";
	static ContentExposureConversationEditTitle = "contentexposure.conversation.editTitle";
	static ContentExposureConversationOpeningLineLabel = "contentexposure.conversation.openingLineLabel";
	static ContentExposureConversationOpeningLineTextLabel = "contentexposure.conversation.openingLineTextLabel";
	static ContentExposureConversationClosingLineLabel = "contentexposure.conversation.closingLineLabel";
	static ContentExposureConversationClosingLineTextLabel = "contentexposure.conversation.closingLineTextLabel";
	static ContentExposureConversationAddCustomFlowText = "contentexposure.conversation.addCustomFlowText";
	static ContentExposureConversationEditCustomFlowText = "contentexposure.conversation.editCustomFlowText";
	static ContentExposureConversationCompleteCheckText = "contentexposure.conversation.completeCheckText";
	static ContentExposureConversationSaveButtonText = "contentexposure.conversation.saveButtonText";
	static ContentExposureConversationCancelButtonText = "contentexposure.conversation.cancelButtonText";
	static ContentExposureConversationNoneOptionText = "contentexposure.conversation.noneOptionText";
	static ContentExposureConversationOpenDialogValidationMessage =
		"contentexposure.conversation.openDialogValidationMessage";
	static ContentExposureConversationCloseDialogValidationMessage =
		"contentexposure.conversation.closeDialogValidationMessage";
	static ContentExposureConversationDeleteCustomFlowLabel = "contentexposure.conversation.deleteCustomFlowLabel";
	static ContentExposureConversationSaveError = "contentexposure.conversation.saveError";
	static ContentExposureDelete = "contentexposure.conversation.delete";
	static ContentExposureDeleteWarn = "contentexposure.conversation.deletewarn";
	static ContentExposureDeleteSuc = "contentexposure.conversation.deletesuc";
	static ContentExposureTeachingActivityExists = "contentexposure.teachingActivities.alreadyExists";
	static ContentExposureTeachingAcitivityLengthExceeds = "contentexposure.teachingActivities.lengthExceeds";
	static ContentExposureObjectiveRemoveObjectiveWarningTitle =
		"contentexposure.objective.removeobjectivewarning.title";
	static ContentExposureObjectiveRemoveObjectiveWarningDescription =
		"contentexposure.objective.removeobjectivewarning.description";
	static ContentExposureSelectLPVText = "contentexposure.selectLPV.text";
	static ContentExposureMethodologyText = "contentexposure.methodology.text";
	static ContentExposureDuplilcateNoTargetLPVText = "contentexposure.duplicate.notarget.lpv.text";
	static ContentExposureSlot = "contentexposure.title.slot";
	static ContentExposureSlotView = "contentexposure.slot.view";
	static ContentExposureSlotAlternate = "contentexposure.slot.alternate";
	static ContentExposureSlotAudio = "contentexposure.slot.audio";
	static ContentExposureSlotVideo = "contentexposure.slot.video";
	static ContentExposureSlotEmptyWarning = "contentexposure.slot.empty";
}

export class REPLocale {
	static REPDuration = "rep.title.duration";
	static REPRelatedItems = "rep.title.relateditems";
	static REPTeachingActivity = "rep.title.teachingactivity";
	static REPObjective = "rep.title.objective";
	static REPAddNewREP = "rep.add.newrep";
	static REPDuplicateREP = "rep.duplicate.rep";
	static REPWarningDelete = "rep.warning.delete";
	static REPSlot = "rep.title.slot";
	static REPSlotAudio = "rep.slot.audio";
	static REPSlotVideo = "rep.slot.video";
	static REPSlotEmptyWarning = "rep.slot.empty";
	static REPSelectLPVText = "rep.selectlpv.text";
	static REPMethodologyText = "rep.methodology.text";
	static REPExposureDuplicateExposureWarning = "rep.action.duplicateexposurewarning";
	static REPDuplilcateLPVText = "rep.duplicate.lpv.text";
	static REPDuplilcateNoTargetLPVText = "rep.duplicate.notargetlpv.text";
}

export class ConversationTemplateLocale {
	static TemplatesText = "template.text.plural";
	static ConversationTemplatesText = "template.masterplural.text";
	static TemplateRemainingText = "template.remaining.text";
	static TemplateValidationText = "template.validation.text";
	static TemplateValidateionType = "template.validation.type";
	static TemplateValidationUniqueText = "template.validation.textunique";
	static TemplateTabFallback = "template.tab.fallback";
	static TemplateTabUtteranceEntities = "template.tab.utteranceentities";
	static TemplateTabCommonIntents = "template.tab.commonintents";
	static TemplateTabConversations = "template.tab.conversations";
	static TemplateTabOpenClose = "template.tab.openclose";
	static TemplateValidationTextLength = "template.validation.textlength";
	static TemplateDeleteTxt = "template.masterDelete.text";
	static TemlateConversationDelWarn = "template.deleteConversation.warn";
	static TemplateConversationUsedMsg = "template.conversationused.msg";
}

export class FallbackLocale {
	static FallbackColumnType = "fallback.column.type";
	static FallbackColumnText = "fallback.column.text";
	static FallbackColumnDelete = "fallback.column.delete";
	static FallbackSilent = "fallback.silent";
	static FallbackNewHeader = "fallback.new.header";
	static FallbackEditHeader = "fallback.edit.header";
	static FallbackDeleteHeader = "fallback.delete.header";
	static FallbackAddSuccess = "fallback.msg.addsuccess";
	static FallbackDeleteSuccess = "fallback.msg.deletesuccess";
	static FallbackUpdateSuccess = "fallback.msg.updatesucess";
	static FallbackDeleteMsg = "fallback.msg.delete";
	static FallbackCustom = "fallback.custom";
	static FallbackRegular = "fallback.regular";
	static FallbackFallback = "fallback.fallback";
	static FallbackTemplateText = "fallback.template.text";
	static FallbackDeleteAlternateText = "fallback.msg.deletealternatetext";
}

export class OpenCloseLocale {
	static OpenCloseColumnType = "openclose.column.type";
	static OpenCloseColumnText = "openclose.column.text";
	static OpenCloseColumnDelete = "openclose.column.delete";
	static OpenCloseOpen = "openclose.open";
	static OpenCloseTypeClose = "openclose.close";
	static OpenCloseOther = "openclose.other";
	static OpenCloseNewHeader = "openclose.new.header";
	static OpenCloseEditHeader = "openclose.edit.header";
	static OpenCloseDeleteHeader = "openclose.delete.header";
	static OpenCloseAddSuccess = "openclose.msg.addsuccess";
	static OpenCloseDeleteSuccess = "openclose.msg.deletesuccess";
	static OpenCloseUpdateSuccess = "openclose.msg.updatesucess";
	static OpenCloseAll = "openclose.all";
	static OpenCloseValidationTag = "openclose.validation.tag";
	static OpenCloseDeleteMsg = "openclose.msg.delete";
	static OpenCloseTypeUsedMsg = "openclose.typeused.msg";
	static OpenCloseDeleteConvUsedMsg = "openclose.deleteconvused.msg";
}

export class CommonEntitiesFormLocale {
	static CommonEntitiesFormCreateTitle = "commonentities.form.createtitle";
	static CommonEntitiesFormEditTitle = "commonentities.form.edittitle";
	static CommonEntitiesFormAddEntityButtonText = "commonentities.form.addentitybuttontext";
	static CommonEntitiesFormNameLabel = "commonentities.form.namelabel";
	static CommonEntitiesFormEntiyItemsLabel = "commonentities.form.itemslabel";
	static CommonEntitiesFormSavedSuccessMessage = "commonentities.form.savesuccessmessage";
	static CommonEntitiesFormNameAlreadyExistMessage = "commonentities.form.namealreadyexistmessage";
	static CommonEntitiesFormNameNotValidMessage = "commonentities.form.namenotvalidmessage";
	static CommonEntitiesFormDuplicateEntityItemMessage = "commonentities.form.duplicateentitymessage";
	static CommonEntitiesFormStrongAssociationMessage = "commonentities.form.strongassociationmessage";
	static CommonEntitiesFormSaveButtonText = "commonentities.form.savebuttontext";
	static CommonEntitiesFormCancelButtonText = "commonentities.form.cancelbuttontext";
	static CommonEntitiesFormNameRequiredMessage = "commonentities.form.namerequiredmessage";
	static CommonEntitiesFormNameLengthMessage = "commonentities.form.namelengthmessage";
	static CommonEntitiesFormItemsRequiredMessage = "commonentities.form.itemsrequiredmessage";
	static CommonEntitiesFormItemsNameRequiredMessage = "commonentities.form.itemsnamerequiredmessage";
	static CommonEntitiesFormItemsEditItemTooltip = "commonentities.form.edititemtooltip";
	static CommonEntitiesFormItemsDeleteItemTooltip = "commonentities.form.deleteitemtooltip";
	static CommonEntitiesFormItemsSaveItemTooltip = "commonentities.form.saveitemtooltip";
	static CommonEntitiesFormItemsEntityNotExistMessage = "commonentities.form.entitynotexistmessage";
}

export class CommonIntentsFormLocale {
	static CommonIntentsFormCreateTitle = "commonintents.form.createtitle";
	static CommonIntentsFormEditTitle = "commonintents.form.edittitle";
	static CommonIntentsFormAddUtteranceButtonText = "commonintents.form.addutterancebuttontext";
	static CommonIntentsFormNameLabel = "commonintents.form.namelabel";
	static CommonIntentsFormUtterancesLabel = "commonintents.form.utteranceslabel";
	static CommonIntentsFormSavedSuccessMessage = "commonintents.form.savesuccessmessage";
	static CommonIntentsFormNameAlreadyExistMessage = "commonintents.form.namealreadyexistmessage";
	static CommonIntentsFormNameNotValidMessage = "commonintents.form.namenotvalidmessage";
	static CommonIntentsFormDuplicateUtteranceMessage = "commonintents.form.duplicateutterancemessage";
	static CommonIntentsFormStrongAssociationMessage = "commonintents.form.strongassociationmessage";
	static CommonIntentsFormSaveButtonText = "commonintents.form.savebuttontext";
	static CommonIntentsFormCancelButtonText = "commonintents.form.cancelbuttontext";
	static CommonIntentsFormNameRequiredMessage = "commonintents.form.namerequiredmessage";
	static CommonIntentsFormNameLengthMessage = "commonintents.form.namelengthmessage";
	static CommonIntentsFormUtterancesRequiredMessage = "commonintents.form.utterancesrequiredmessage";
	static CommonIntentsFormUtteranceValueRequiredMessage = "commonintents.form.utterancevaluerequiredmessage";
	static CommonIntentsFormUtteraneEditItemTooltip = "commonintents.form.utteranceedititemtooltip";
	static CommonIntentsFormUtteranceDeleteItemTooltip = "commonintents.form.utterancedeleteitemtooltip";
	static CommonIntentsFormUtteranceSaveItemTooltip = "commonintents.form.utterancesaveitemtooltip";
	static CommonIntentsFormIntentNotExistMessage = "commonintents.form.intentnotexistmessage";
	static CommonIntentsFormUtteranceLengthMessage = "commonintents.form.utterancelengthmessage";
	static CommonIntentsFormUtteranceMinLengthMessage = "commonintents.form.utteranceminlengthmessage";
	static CommonIntentsFormUtteranceEntityAssociationMessage = "commonintents.form.utteranceentityassociationmessage";
	static CommonIntentsFormUtteranceEntityLabel = "commonintents.form.utteranceentitylabel";
	static CommonIntentsFormUtteranceInvalidEntity = "commonintents.form.utteranceinvalidentity";
}

export class CommonIntentsLocale {
	static CommonIntentsNameColumnHeading = "common.intents.namecolumnheading";
	static CommonIntentsPathCountColumnHeading = "common.intents.pathcountcolumnheading";
	static CommonIntentsConversationCountColumnHeading = "common.intents.conversationcountcolumnheading";
	static CommonIntentsUtteranceCountColumnHeading = "common.intents.utterancecountcolumnheading";
	static CommonIntentsDeleteColumnHeading = "common.intents.deletecolumnheading";
	static CommonIntentsAddCommonIntentButtonText = "common.intents.addcommonintentbuttontext";
	static CommonIntentsNotExistErrorMessage = "common.intents.notexisterrormessage";
	static CommonIntentsStrongAssociationMessage = "common.intents.strongassociationmessage";
	static CommonIntentsDeleteSuccessMessage = "common.intents.deletesuccessmessage";
	static CommonIntentsDeleteButtonText = "common.intents.deletebuttontext";
	static CommonIntentsDeleteWarning = "common.intents.deletewarning";
}
export class UtteranceEntitiesLocale {
	static UtteranceEntitiesNameColumnHeading = "utterance.entities.namecolumnheading";
	static UtteranceEntitiesItemCountColumnHeading = "utterance.entities.itemcountcolumnheading";
	static UtteranceEntitiesConversationCountColumnHeading = "utterance.entities.conversationcountcolumnheading";
	static UtteranceEntitiesUtteranceCountColumnHeading = "utterance.entities.utterancecountcolumnheading";
	static UtteranceEntitiesDeleteColumnHeading = "utterance.entities.deletecolumnheading";
	static UtteranceEntitiesAddCommonEntityButtonText = "utterance.entities.addcommonentitybuttontext";
	static UtteranceEntitiesStrongAssociationMessage = "utterance.entities.strongassociationmessage";
	static UtteranceEntitiesDeleteSuccessMessage = "utterance.entities.deletesuccessmessage";
	static UtteranceEntitiesDeleteButtonText = "utterance.entities.deletebuttontext";
	static UtteranceEntitiesDeleteWarning = "utterance.entities.deletewarning";
}

export class ConversationMasterBuilderLocale {
	static ComponentColumn = "convmasterbuilder.component.column";
	static GeneralColumn = "convmasterbuilder.general.column";
	static ExposureText = "convmasterbuilder.text.exposure";
}

export class ObjectiveListLocale {
	static ObjectiveListTitle = "objectiveList.title";
}

export class ConversationTestWidgetLocale {
	static ConversationTestButtonText = "conversation.testwidget.testbuttontext";
	static ConversationWidgetTitle = "conversation.testwidget.title";
	static ConversationTextAreaPlaceholder = "conversation.testwidget.textareaplaceholder";
	static ConversationIdInvalidMessage = "conversation.testwidget.idinvalidmessage";
	static ConversationInfoInvalidMessage = "conversation.testwidget.infoinvalidmessage";
	static ConversationNoHeadMessage = "conversation.testwidget.noheadmessage";
	static ConversationEndErrorMessage = "conversation.testwidget.enderrormessage";
	static ConversationEndMessage = "conversation.testwidget.endmessage";
	static ConversationNoSpeechMessage = "conversation.testwidget.nospeechmessage";
	static ConversationLoadingMessage = "conversation.testwidget.loadingmessage";
	static ConversationErrorLoadingMessage = "conversation.testwidget.errorloadingmessage";
	static ConversationViewDetailsLabel = "conversation.testwidget.viewdetailslabel";
	static ConversationViewDetailsTitle = "conversation.testwidget.viewdetailstitle";
	static ConversationSendButton = "conversation.testwidget.sendbutton";
}

export class ConversationBuilderLocale {
	static ConversationStartWarning = "conversation.start.warning";
	static ConversationMaxNodeCountWarning = "conversation.maxnodecount.warning";
	static ConversationTargetDialog = "conversation.target.dialog";
	static ConversationNotFound = "converation.api.notfound.error";
	static ConversationDeleteWarn = "conversation.delete.warning";
	static ConversationDeleteContent = "conversation.delete.text";
	static ConversationEntityIntentUnique = "conversation.entityintent.unique";
	static ConversationUtterenceUnique = "conversation.utterence.unique";
	static ConversationDialogNameInValidMsg = "conversation.dialog.validatename";
	static ConversationDialogConclusionRequiredMsg = "conversation.dialog.conclusionrequiredmsg";
	static ConversationDialogTxtInValidMsg = "conversation.dialog.validatetext";
	static ConversationDialogRetryInValidMsg = "conversation.dialog.validateretry";
	static ConversationDialogInteractionStyleInvalidMsg = "conversation.dialog.validateinteractionstyle";
	static ConversationDialogStartInteractionStyleInvalidMsg = "conversation.dialog.validatestartinteractionstyle";
	static ConversationPathRequiredMsg = "conversation.path.required";
	static ConversationPathNameInValidMsg = "conversation.path.validatename";
	static ConversationPathInteractionStyleInvalidMsg = "conversation.path.validateinteractionstyle";
	static ConversationPathEntityValueRequired = "conversation.path.entityvaluerequired";
	static ConversationPathDefaultName = "conversation.path.defaultname";
	static ConversationPathDefaultFallbackName = "conversation.path.defaultfallbackname";
	static ConversationPathIntentRequired = "conversation.path.intentrequired";
	static ConversationPathTooManyConnections = "conversation.path.toomanyconnections";
	static ConversationIntentNameInValidMsg = "conversation.intent.validatename";
	static ConversationIntentNameInvalidCharMsg = "conversation.intent.invalidchar";
	static ConversationIntentUtterenceInvalidMsg = "conversation.intent.validateutterence";
	static ConversationIntentUtteranceInvalidEntityMsg = "conversation.intent.utteranceinvalidentity";
	static ConversationIntentUtteranceUniqueMsg = "conversation.intent.utterancenotunique";
	static ConversationIntentUtteranceInvalidLength = "conversation.intent.invalidlength";
	static ConversationIntentUtteranceRequired = "conversation.intent.utterancerequired";
	static ConversationIntentUtteranceCountInvalid = "conversation.intent.utterancecountinvalid";
	static ConversastionIntentNameRequired = "conversation.intent.namerequired";
	static ConversationNameInvalidMsg = "conversation.name.invalidmsg";
	static ConversationEntityInValidMsg = "conversation.entity.validatename";
	static ConversationEntityInvalidChar = "conversation.entity.invalidchar";
	static ConversatoinStartNodeRequired = "conversation.start.requiredmsg";
	static ConversationRemoveOrphanConnectorsMsg = "conversation.connectors.removeorphanmsg";
	static ConversationRemoveUnconnectedConnectorMsg = "conversation.connectors.removeunconnectedmsg";
	static ConversationAddNodesMsg = "conversation.nodes.addmsg";
	static ConverstionTrainText = "conversation.train.text";
	static ConversationCreateText = "conversation.create.text";
	static ConversationSelSpeedText = "conversation.selectSpeed.text";
	static ConverationTestUX = "conversation.testux.text";
	static ConversationDialogText = "conversation.dialog.text";
	static ConversationPathText = "conversation.intent.text";
	static ConversationStartText = "conversation.start.text";
	static ConversationConnectorText = "conversation.connector.text";
	static ConversationToolboxText = "conversation.toolbox.text";
	static ConversationPublishingMsg = "conversation.publishing.msg";
	static ConversationPublishedMsg = "conversation.published.msg";
	static ConversationPublishFailedMsg = "conversation.publishfailed.msg";
	static ConversationPublishingTestMsg = "conversation.publishingTest.msg";
	static ConversationPublishedTestMsg = "conversation.publishedTest.msg";
	static ConversationPublishFailedTestMsg = "conversation.publishfailedTest.msg";
	static ConversationPublishingVoiceMsg = "conversation.publishingVoice.msg";
	static ConversationPublishedVoiceMsg = "conversation.publishedVoice.msg";
	static ConversationPublishFailedVoiceMsg = "conversation.publishfailedVoice.msg";
	static ConversationPublishingTestVoiceMsg = "conversation.publishingTestVoice.msg";
	static ConversationPublishedTestVoiceMsg = "conversation.publishedTestVoice.msg";
	static ConversationPublishFailedTestVoiceMsg = "conversation.publishfailedTestVoice.msg";
	static ConversationVoiceGenerationOrPublishMsg = "conversation.voiceGenerationOrPublishMsg";
	static ConversationPathMultipleConnectMsg = "conversation.intentmultipleconnect.msg";
	static ConversationExternalNoConnectMsg = "conversation.externalnoconnect.msg";
	static ConversationDialogNoMultipleMsg = "conversation.dialognomultiple.msg";
	static ConversationTargetPathDialogMsg = "conversation.targetintentdialog.msg";
	static ConversationTargetSourceAlreadyConnected = "conversation.targetSourceAlreadyConnected";
	static ConversationPathConnectDialogMsg = "conversation.intentconnectdialog.msg";
	static ConversationTargetSameTypeMsg = "conversation.targetsametype.msg";
	static ConversationDialogNoMoreChild = "conversation.dialognomorechild.msg";
	static ConversationPendingChangesMsg = "conversation.pendingchanges.msg";
	static ConversationAllreadyExits = "conversation.allreadyexists.msg";
	static ConversationNameLengthInvalid = "conversation.name.lengthinvalidmsg";
	static ConversationNameInvalid = "conversation.name.invalidmsg";
	static ConversationDialogImageRemoveMsg = "conversation.dialog.image.remove.msg";
	static ConversationDraftLinkText = "conversation.draftlink.text";
	static ConversationCompleteLinkText = "conversation.completelink.text";
	static ConversationPublishedWarningTitle = "conversation.publishedwarning.title";
	static ConversationPublishedWarningMessage = "conversation.publishedwarning.message";
	static ConversationPublishedStatusErrorMessage = "conversation.publishedstatus.errormessage";
	static ConversationConfirmRemoveNodeWarn = "conversation.confirmremovenode.warn";
	static ConversationConfirmRemoveNodesWarn = "conversation.confirmremovenodes.warn";
	static ConversationConfirmRemoveNodeCancelTxt = "conversation.confirmremovenode.cancelTxt";
	static ConversationConfirmRemoveNodeOkTxt = "conversation.confirmremovenode.okTxt";
	static ConversationIntentUtteranceInvalidCharMsg = "conversation.intent.utterance.invalidcharmsg";
	static ConversationVoiceGenTestTimeCountDownLabel = "conversation.voicegen.testtimecountdownlabel";
	static ConversationVoiceGenTimeCountDownLabel = "conversation.voicegen.timecountdownlabel";
	static ConversationEntitySynonymsMaxCountReachedMsg = "conversation.entitysynonyms.maxcountreachedmsg";
	static ConversationProjectSynonymsMaxCountReachedMsg = "conversation.projectsynonyms.maxcountreachedmsg";
	static ConversationEntityCountValidationMsg = "conversation.entitycount.validationmsg";
	static ConversationIntentCountValidationMsg = "conversation.intentcount.validationmsg";
	static ConversationUtterancesCountValidationMsg = "conversation.utterancescount.validationmsg";
	static ConversationDuplicateUtteranceWarningText = "conversation.duplicateutterance.warningtext";
}

export class IntentLocale {
	static IntentManageTitle = "intent.manage.title";

	static IntentNameLabel = "intent.name.label";
	static IntentNameRequiredMsg = "intent.name.required";
	static IntentNameInvalidCharMsg = "intent.name.invalidcharmsg";
	static IntentNameLengthLimitMsg = "intent.name.lengthlimitmsg";
	static IntentNameUniqueMsg = "intent.name.unique";

	static IntentCommonText1 = "intent.manage.common.text1";
	static IntentCommonText2 = "intent.manage.common.text2";
	static IntentCommonText3 = "intent.manage.common.text3";
	static IntentCommonText4 = "intent.manage.common.text4";
	static IntentCommonText5 = "intent.manage.common.text5";

	static IntentLocalText = "intent.manage.local";

	static IntentUsageLabel = "intent.usage.label";

	static IntentUtteranceLabel = "intent.utterance.label";
	static IntentUtteranceInvalid = "intent.utterance.invalid";
	static IntentUtteranceDeleteConfirmation = "intent.utterance.delete.confirmation";

	static IntentEntityLabel = "intent.entity.label";
	static IntentEntityPlaceholder = "intent.entity.placeholder";
	static IntentEntityNew = "intent.entity.new";
	static IntentEntityRequired = "intent.entity.required";
	static IntentEntityNameUnique = "intent.entity.unique";
	static IntentEntityInfoText1 = "intent.entity.info.text1";
	static IntentEntityInfoText2 = "intent.entity.info.text2";
	static IntentEntityInfoText3 = "intent.entity.info.text3";
	static IntentEntityInfoText4 = "intent.entity.info.text4";
	static IntentEntityInfoText5 = "intent.entity.info.text5";
	static IntentEntityInfoText6 = "intent.entity.info.text6";
	static IntentEntityChangeConfirmationTitle = "intent.entity.change.confirmation.title";
	static IntentEntityChangeConfirmationText = "intent.entity.change.confirmation.text";

	static AddDialogTitle = "intent.add.title";
	static AddDialogTypeRequired = "intent.add.type.required";
	static AddDialogTypeNew = "intent.add.type.new";
	static AddDialogTypeNewPlaceholder = "intent.add.type.new.placeholder";
	static AddDialogTypeExisting = "intent.add.type.existing";
	static AddDialogTypeExistingPlaceholder = "intent.add.type.existing.placeholder";
	static AddDialogTypeCommon = "intent.add.type.common";
	static AddDialogTypeCommonPlaceholder = "intent.add.type.common.placeholder";
	static AddDialogSubmit = "intent.add.submit";

	static IntentDuplicateUtterance = "intent.utterance.duplicate";
	static IntentUtteranceLengthInvalid = "intent.utterance.lengthinvalid";
	static IntentEntityInvalid = "intent.entity.invalid";
	static IntentEntityUtterenceInvalid = "intent.entity.utterenceinvalid";
	static PatternedUtterancesLengthInvalid = "patternedutterances.lengthinvalid.msg";
}

export class ConversationBreadcrumbLocale {
	static ConversationMasterText = "conversation.breadbcrumb.master";
	static ConversationExposureText = "conversation.breadcrumb.exposure";
}

export class ContentExposureTeachObjLocale {
	static Insert = "contentexposure.teachObj.insert";
	static Cancel = "contentexposure.teachObj.cancel";
	static Update = "contentexposure.teachObj.update";
	static ConfirmInsertEditWarn = "contentexposure.teachObj.confirmInsertEditWarn";
	static ConfirmCancelTxt = "contentexposure.teachObj.confirmCancelTxt";
	static ConfirmOkTxt = "contentexposure.teachObj.confirmOkTxt";
}

export class ImageEditorLocale {
	static WarningMsg = "imageeditor.warning.imagechange.msg";
}
export class EntityValueLocale {
	static EntityValueLabel = "entity.value.label";
	static EntityValueNoValues = "entity.value.novalues";
	static EntityValueContainAtLeastOneValue = "entity.value.containatleastone";
	static EntityValueSelectAtLeastOneValue = "entity.value.selectatleastone";
	static EntityValueRequired = "entity.value.required";
	static EntityValueUnique = "entity.value.unique";
	static EntityValueLengthInvalid = "entity.value.lengthinvalid";
	static EntityValueAlreadyExists = "entity.value.alreadyexists";
	static EntityValueSelectAllLabel = "entity.value.selectalllabel";
}

export class MediaUploaderLocale {
	static MediaUploaderButtonSave = "mediauploader.save.button.text";
	static MediaUploaderButtonCancel = "mediauploader.cancel.button.text";
	static MediaUploaderButtonView = "mediauploader.view.button.text";
	static MediaUploaderButtonListen = "mediauploader.listen.button.text";
	static MediaUploaderButtonDelete = "mediauploader.delete.button.text";
	static MediaUploaderSlotInfoText = "mediauploader.slotinfo.text";
	static MediaUploaderSlotText = "mediauploader.slot.text";
	static MediaUploaderUploadAFileText = "mediauploader.uploadafile.text";
	static MediaUploaderOrDragAndDropText = "mediauploader.ordraganddrop.text";
	static MediaUploaderFileTypeOnlyText = "mediauploader.filetypeonly.text";
	static MediaUploaderFileTypeText = "mediauploader.filetype.text";
	static MediaUploaderCurrentMediaText = "mediauploader.currentmedia.text";
	static MediaUploaderNewMediaText = "mediauploader.newmedia.text";
	static MediaUploaderUploadedText = "mediauploader.uploaded.text";
	static MediaUploaderBreakIntoImagesText = "mediauploader.breakintoimages.text";
	static MediaUploaderKeepExistingTimingText = "mediauploader.keepexistingtiming.text";
	static MediaUploadScheduledWarning = "mediauploader.warning.media.scheduled";
	static MediaUploadSuccessMsg = "mediauploader.success.msg";
	static MediaUploadStatusText = "mediauploader.status.text";
	static MediaUploadMediaViewerText = "mediauploader.mediaViewer.text";
	static MediaUploadFileNameText = "mediauploader.mediaViewer.filename.text";
	static MediaUploadFileSizeText = "mediauploader.mediaViewer.filesize.text";
	static MediaUploaderSelectDisplayContentText = "mediauploader.selectdisplaycontent.text";
	static MediaUploaderWarningModalTitleText = "mediauploader.warningmodal.title.text";
	static MediaUploaderWarningModalBodyText = "mediauploader.warningmodal.body.text";
	static MediaUploaderWarningModalSaveChangesText = "mediauploader.warningmodal.save.changes.text";
	static MediaUploaderWarningModalButtonText = "mediauploader.warningmodal.button.text";
}

export class MediaLocale {
	static MediaViewingContentText = "media.viewingcontent.text";
	static MediaAlternateContentText = "media.alternatecontent.text";
	static MediaAudioText = "media.audio.text";
	static MediaAudioBackgroundText = "media.audiobackground.text";
	static MediaOfflineVideoText = "media.offlinevideo.text";
	static MediaStreamingVideoText = "media.streamingvideo.text";
	static MediaTeacherManualText = "media.teachermanual.text";
	static MediaThumbnailText = "media.thumbnail.text";
	static MediaImageText = "media.image.text";
	static MediaIndividualAudioText = "media.individualaudio.text";
	static MediaTypePdf = "media.type.pdf";
	static MediaTypeMp3 = "media.type.mp3";
	static MediaTypeMp4 = "media.type.mp4";
	static MediaTypePng = "media.type.png";
}

export class MediaTabLocale {
	static MediaTabYes = "media.tab.yes";
	static MediaTabNo = "media.tab.no";
	static MediaTabSlotColumn = "media.tab.slotcolumn";
	static MediaTabFileTypeColumn = "media.tab.fileType";
	static MediaTabExistsColumn = "media.tab.exists";
}

export class MediaViewerLocale {
	static MediaViewerPageText = "mediaviewer.page.text";
	static MediaViewerReferencesText = "mediaviewer.references.text";
	static MediaViewerTeacherUseOnlyText = "mediaviewer.teacherUseOnly.text";
	static MediaViewerNoImagesFoundText = "mediaviewer.noImagesFound.text";
	static MediaViewerViewingContentProcessingText = "mediaviewer.viewingContentProcessing.text";
	static MediaViewerTeacherManualProcessingText = "mediaviewer.teacherManualProcessing.text";
	static MediaViewerAudioBackgroundProcessingText = "mediaviewer.audioBackgroundProcessing.text";
	static MediaViewerProcessingText = "mediaviewer.processingState.text";
}

export class RevisionMangerLocale {
	static RevisionMangerPageTitle = "revisionmanger.page.title";
	static RevisionMangerScheduleText = "revisionmanger.page.scheduletext";
	static RevisionManagaerSchMdlScheduleText = "revisionmanger.page.schmdl.scheduletext";
	static RevisionManagaerSchMdlDescText = "revisionmanger.page.schmdl.desctext";
	static RevisionManagaerSchMdlScheduledPublishText = "revisionmanger.page.schmdl.scheduledPublishtext";
	static RevisionManagaerSchMdlPublishImmediatelyText = "revisionmanger.page.schmdl.publishImmediatelytext";
	static RevisionManagaerSchMdlSelectdateText = "revisionmanger.page.schmdl.selectdatetext";
	static RevisionManagaerSchMdlNoteText = "revisionmanger.page.schmdl.notetext";
	static RevisionManagaerRevMdlRevisedMediaText = "revisionmanger.page.revmdl.revisedtext";
	static RevisionManagaerRevMdlRevisionText = "revisionmanger.page.revmdl.revisiontext";
	static RevisionManagaerSchMdlMediaScheduledText = "revisionmanger.schmdl.mediascheduletext";
	static RevisionManagaerSchMdlMediaPublishedText = "revisionmanger.schmdl.mediapublishedtext";
	static RevisionManagaerRevMdlMediaNotesSavedText = "revisionmanger.schmdl.medianotessavedtext";
	static RevisionManagaerSchMdlMediaPublishWarning = "revisionmanger.schmdl.mediapublishwarning";
}

export class BreadCrumbMenuLocale {
	static BreadCrumbMenuLPV = "breadcrumbmenu.lpv";
	static BreadCrumbMenuLPList = "breadcrumbmenu.lplist";
	static BreadCrumbMenuMasterPlan = "breadcrumbmenu.masterplan";
	static BreadCrumbMenuLPEditor = "breadcrumbmenu.lpeditor";
	static BreadCrumbMenuPlaylistEditor = "breadcrumbmebu.playlisteditor";
}

export class LPActivitiesLocale {
	static LPActivitiesDrawerAddActivitytitle = "lpactivities.drawer.addactivitytitle";
	static LPActivitiesDrawerEditActivitytitle = "lpactivities.drawer.editactivitytitle";
	static LPActivitiesDrawerReferencesActivitytitle = "lpactivities.drawer.referencesactivitytitle";
	static LPActivitiesDrawerCancelBtnText = "lpactivities.drawer.cancelbtntxt";
	static LPActivitiesDrawerSaveBtnText = "lpactivities.drawer.savebtntxt";
	static LPActivitiesPageAddActivityText = "lpactivities.page.addactivitytxt";
	static LPActivitiesGridColumnNameText = "lpactivities.grid.column.nametxt";
	static LPActivitiesGridColumnStartUnitText = "lpactivities.grid.column.startunittxt";
	static LPActivitiesGridColumnEndUnitText = "lpactivities.grid.column.endunittxt";
	static LPActivitiesGridColumnDurationText = "lpactivities.grid.column.durationtxt";
	static LPActivitiesGridColumnReferencesText = "lpactivities.grid.column.referencestxt";
	static LPActivitiesGridColumnTypeText = "lpactivities.grid.column.typetxt";
	static LPActivitiesGridColumnMethodologiesText = "lpactivities.grid.column.methodologiestxt";
	static LPActivitiesPageActvitiesTitle = "lpactivities.page.activitiestitle";
	static LPActivitiesDrawerRadioLSText = "lpactivities.drawer.radiolstxt";
	static LPActivitiesDrawerRadioGSText = "lpactivities.drawer.radiogstxt";
	static LPActivitiesDrawerNamePlaceholderText = "lpactivities.drawer.nameplaceholdertxt";
	static LPActivitiesDrawerDurationErrorText = "lpactivities.drawer.durationerrortxt";
	static LPActivitiesDrawerSaveActivitySuccessText = "lpactivities.drawer.saveactivitysuccesstxt";
	static LPActivitiesDrawerSaveActivityErrorText = "lpactivities.drawer.saveactivityerrortxt";
	static LPActivitiesDrawerNameRequiredText = "lpactivities.drawer.namerequiredtxt";
	static LPActivitiesDrawerNameUniqueText = "lpactivities.drawer.nameuniquetxt";
	static LPActivitiesDrawerNameCharactersExceedText = "lpactivities.drawer.namecharacexceedtxt";
	static LPActivitiesDrawerMethodologiesRequiredText = "lpactivities.drawer.methodologiesrequiredtxt";
	static LPActivitiesDrawerReferencesUnitColumn = "lpactivities.drawer.references.unitcolumn";
	static LPActivitiesDrawerReferencesLPColumn = "lpactivities.drawer.references.lpcolumn";
	static LPActivitiesDrawerReferencesCountColumn = "lpactivities.drawer.references.countcolumn";
	static LPActivitiesDrawerReferencesTitle = "lpactivities.drawer.references.title";
	static LPActivitiesDrawerReferencesCloseText = "lpactivities.drawer.references.closetxt";
	static LPActivitiesDrawerLPVText = "lpactivities.drawer.references.lpvtxt";
}

export class ConversationLocale {
	static ConversationPageTitle = "conversation.page.title";
}

export class AssetListLocale {
	static AssetListPageTitle = "assetlist.page.title";
	static AssetListPageAddNewAsset = "assetlist.page.addnewasset";
	static AssetListPageAssetSearch = "assetlist.page.assetsearch";
	static AssetListPageAssetSearchPlaceholder = "assetlist.page.assetsearchplaceholder";
	static AssetListPageAssetUnitFilter = "assetlist.page.assetunitfilter";
	static AssetListPageAllUnitText = "assetlist.page.allunittext";
	static AssetListPageAssetSearchBtnTxt = "assetlist.page.searchbtntxt";
	static AssetListGridTagsPopoverText = "assetlist.grid.tagspopovertxt";
	static AssetListGridTagsTooltipText = "assetlist.grid.tagstooltiptxt";
	static AssetListGridHeaderId = "assetlist.grid.header.id";
	static AssetListGridHeaderDescription = "assetlist.grid.header.description";
	static AssetListGridHeaderComponent = "assetlist.grid.header.component";
	static AssetListGridHeaderUnit = "assetlist.grid.header.unit";
	static AssetListGridHeaderReferences = "assetlist.grid.header.references";
	static AssetListGridHeaderTarget = "assetlist.grid.header.target";
	static AssetListGridHeaderTags = "assetlist.grid.header.tags";
	static AssetListGridTagsSavetext = "assetlist.grid.header.tagssavetxt";
	static AssetListDrawerIdLabel = "assetlist.drawer.idlabel";
	static AssetListDrawerDescriptionLabel = "assetlist.drawer.descriptionlabel";
	static AssetListDrawerUnitLabel = "assetlist.drawer.unitlabel";
	static AssetListDrawerComponentLabel = "assetlist.drawer.componentlabel";
	static AssetListGridAddtagLabel = "assetlist.grid.addtaglabel";
	static AssetListGridAddTagsTooltipText = "assetlist.grid.addtagstooltiptxt";
	static AssetListDrawerImageLabel = "assetlist.drawer.Imagelabel";
	static AssetListDrawerTagsLabel = "assetlist.drawer.Tagslabel";
	static AssetListDrawerCancelLabel = "assetlist.drawer.Cancellabel";
	static AssetListDrawerSaveLabel = "assetlist.drawer.Savelabel";
	static AssetListDrawerDeleteLabel = "assetlist.drawer.Deletelabel";
	static AssetListImageSumbitTxt = "assetlist.image.submittxt";
	static AssetListImageCancelTxt = "assetlist.image.canceltxt";
	static AssetListAssetDeleteFailedText = "assetlist.asset.deletefailedtxt";
	static AssetListAssetDeleteSuccessText = "assetlist.asset.deletesuccesstxt";
	static AssetListAssetSaveSuccessText = "assetlist.asset.savesuccesstxt";
	static AssetListAssetSaveFailedText = "assetlist.asset.savefailedtxt";
	static AssetListDrawerAddAssetText = "assetlist.drawer.addassettxt";
	static AssetListDrawerEditAssetText = "assetlist.drawer.editassettxt";
	static AssetListDrawerDescriptionRequiredText = "assetlist.drawer.descriptionrequiredtxt";
	static AssetListDrawerDescriptionLengthErrorText = "assetlist.drawer.descriptionLengthErrortxt";
	static AssetListDrawerTagNameLengthErrorText = "assetlist.drawer.tagNameLengthErrortxt";
	static AssetListDrawerTagNameUniqueErrorText = "assetlist.drawer.tagNameuniqueErrortxt";
	static AssetListDrawerDeleteAssetTitle = "assetlist.drawer.deleteassettitle";
	static AssetListDrawerDeleteAssetOkText = "assetlist.drawer.deleteassetoktxt";
	static AssetListDrawerDeleteAssetCancelText = "assetlist.drawer.deleteassetcanceltxt";
}

export class FocusWordsLocale {
	static FocusWordsPageTitle = "focuswords.page.title";
	static FocusWordsVersionMessage = "focuswords.versionMessage";
	static FilterSearchLabel = "focuswords.filter.searchLabel";
	static FilterUnitLabel = "focuswords.filter.unitLabel";
	static FocusWordsAllLevelOption = "focuswords.alllevel.option";
	static FocusWordsNoneLevelOption = "focuswords.nonelevel.option";
	static FilterButton = "focuswords.filter.button";
	static ActionAdd = "focusword.action.add";
	static GridNoText = "focusword.grid.notext";
	static GridYesText = "focusword.grid.yestext";
	static GridTextColumn = "focusword.grid.textColumn";
	static GridDefinitionColumn = "focusword.grid.definitionColumn";
	static GridStartUnitColumn = "focusword.grid.startUnitColumn";
	static GridAdditionalUnitsColumn = "focusword.grid.additionalUnitsColumn";
	static GridAudioColumn = "focusword.grid.audioColumn";
	static GridDefinitionAudioColumn = "focusword.grid.definitionAudioColumn";
	static GridImageColumn = "focusword.grid.imageColumn";
}

export class FocusWordsFormLocale {
	static AddWordDrawerTitle = "focuswords.drawertitle.addword";
	static EditWordDrawerTitle = "focuswords.drawertitle.editword";
	static WordLabel = "focuswords.form.wordlabel";
	static WordRequiredMessage = "focuswords.form.wordrequiredmessage";
	static StartUnitLabel = "focuswords.form.startunitlabel";
	static DefinitionLabel = "focuswords.form.definitionlabel";
	static DefinitionAudioLabel = "focuswords.form.definitionaudio.label";
	static DefinitionRequiredMessage = "focuswords.form.definitionrequiredmessage";
	static MediaUpload = "focuswords.form.mediaupload";
	static AdditionalUnitLabel = "focuswords.form.additionalunitlabel";
	static AddAdditionalUnitsBtn = "focuswords.addadditional.btn";
	static DeleteButton = "focuswords.form.deletebutton";
	static CancelButton = "focuswords.form.cancelbutton";
	static SaveButton = "focuswords.form.savebutton";
	static DeleteConfirmationTitle = "focuswords.deleteConfirmationTitle";
	static DeleteConfirmationText = "focuswords.deleteConfirmationText";
	static DeleteConfirmationYes = "focuswords.deleteConfirmationYes";
	static DeleteConfirmationCancel = "focuswords.deleteConfirmationCancel";
	static MediaInvalid = "focuswords.form.mediainvalid";
	static MediaSizeInvalid = "focuswords.form.mediasizeinvalid";
	static RemoveAssociationsModalError = "focuswords.form.removeassociation.modalerror";
	static RemoveAssociationsModalLinkMessage = "focuswords.form.removeassociation.modallink.message";
	static RemoveAssociationsModalOkButtonText = "focuswords.form.removeassociation.modalokbutton.text";
	static WordAlreadyExistsMessage = "focuswords.form.wordalreadyexits.message";
	static WordAddedSuccessfullyMessage = "focuswords.form.wordaddedsuccess.message";
	static WordEditedSuccessfullyMessage = "focuswords.form.wordeditedsuccess.message";
	static WordDeletedSuccessfullyMessage = "focuswords.form.worddeletedsuccess.message";
	static UnitChangeFailedMessage = "focuswords.form.unitchangefailed.message";
	static FocusWordDefinitionDeleteFailedMessage = "focuswords.form.focusWordDefinitionDeleteFailed.message";
}
export class FocusWordsAssociationLocale {
	static RemoveAssociationsModalError = "focuswords.removeassociation.modalerror";
	static RemoveAssociationsModalLinkMessage = "focuswords.removeassociation.modallink.message";
	static RemoveAssociationsModalOkButtonText = "focuswords.removeassociation.modalokbutton.text";
	static TableColumnHeadingWord = "focuswords.tablecolumn.heading.word";
	static TableColumnHeadingChapter = "focuswords.tablecolumn.heading.chapter";
}

export class ContentExposureManageOrderLocale {
	static CEMOTitle = "cemo.drawer.title";
	static CEMOApplyOnAllExposureBtnText = "cemo.applyonallexposurebtn.text";
	static CEMOPreviewBtnText = "cemo.previewbtn.text";
	static CEMOAllItemsText = "cemo.allitems.text";
	static CEMOItemsToBeDisplyedText = "cemo.itemtobedisplayed.text";
	static CEMOPreviewItemsFocuswordWordText = "cemo.previewitems.focusoword.word.text";
	static CEMOPreviewItemsFocuswordDefinitionText = "cemo.previewitems.focusoword.definition.text";
	static CEMOApplyOnAllExposuresSuccessText = "cemo.applyonallexposures.success.text";
	static CEMOOrderSaveSuccessText = "cemo.ordersave.success.text";
	static CEMOChapterContentPlayMediaText = "cemo.chaptercontent.playmedia.text";
}

export class MasteryObjectiveReportLocale {
	static MOExportFileMsg = "mo.export.msg";
	static MOGridLabelLevelNumber = "mo.grid.label.levelnumber";
	static MOGridLabelLevel1 = "mo.grid.label.level1";
	static MOGridLabelLevel2 = "mo.grid.label.level2";
	static MOGridLabelevel3 = "mo.grid.label.level3";
	static MOGridLabelUnit = "mo.grid.label.unit";
	static MOGridLabelComponent = "mo.grid.label.component";
	static MOGridLabelLPVType = "mo.grid.label.lpvtype";
	static MOGridLabelLPV = "mo.grid.label.lpv";
	static MOGridLabelContentExposureNumber = "mo.grid.label.cen";
	static MOGridLabelActiveLearnQuestion = "mo.grid.label.alq";
}

export class AuditHistoryLocale {
	static AuditHistoryPageTitle = "audithistory.page.title";
	static AuditHistoryExportExcelFileName = "audithistory.exportexcel.filename";
	static MediaNotFoundText = "audithistory.medianotfound";
}
